// src/components/stripe/close-toolbar-mutation.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    id\n    description\n    token\n    theme\n    size\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBannerFragment on UIBanner {\n    heading\n    message\n    icon {\n      ...EGDSIconFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSImageFragment on Image {\n    description\n    url\n    aspectRatio\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    id\n    description\n    orientation\n    size\n    token\n    url {\n      value\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesInteractionAnalyticEventFragment on AffiliatesInteractionAnalyticEvent {\n    eventName\n    eventVersion\n    payload\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesImpressionAnalyticEventFragment on AffiliatesImpressionAnalyticEvent {\n    eventName\n    eventVersion\n    payload\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesCopyLinkActionFragment on AffiliatesCopyLinkAction {\n    url\n    toast {\n      ... on EGDSToast {\n        egdsElementId\n        text\n      }\n    }\n    analytics {\n      ...AffiliatesInteractionAnalyticEventFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesCreateLinkActionFragment on AffiliatesCreateLinkAction {\n    analytics {\n      ...AffiliatesInteractionAnalyticEventFragment\n    }\n    unexpectedErrorMessage {\n      ...EGDSBannerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesOutwardLinkActionFragment on AffiliatesOutwardLinkAction {\n    url\n    analytics {\n      ...AffiliatesInteractionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesStandardLinkFragment on AffiliatesStandardLink {\n    text\n    subtext\n    disabled\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesViewStatsActionFragment on AffiliatesViewStatsAction {\n    analytics {\n      ...AffiliatesInteractionAnalyticEventFragment\n    }\n    unexpectedErrorMessage {\n      ...EGDSBannerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSRequiredInputValidationFragment on EGDSRequiredInputValidation {\n    errorMessage\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSRegexInputValidationFragment on EGDSRegexInputValidation {\n    errorMessage\n    pattern\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesTextInputFieldFragment on AffiliatesTextInputField {\n    handle {\n      egdsElementId\n      label\n      placeholder\n      validations {\n        ...EGDSRequiredInputValidationFragment\n        ...EGDSRegexInputValidationFragment\n      }\n    }\n    selectionAction {\n      ... on AffiliatesTextFieldSelectionAction {\n        analytics {\n          ...AffiliatesInteractionAnalyticEventFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesButtonFragment on AffiliatesButton {\n    button {\n      icon {\n        id\n        token\n        description\n        size\n        theme\n      }\n      primary\n      accessibility\n      disabled\n    }\n    showActionProgress\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesCopyLinkButtonFragment on AffiliatesButton {\n    ...AffiliatesButtonFragment\n    action {\n      ...AffiliatesCopyLinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesIconTextFragment on AffiliatesIconText {\n    text {\n      ... on EGDSStylizedText {\n        size\n        text\n        theme\n        weight\n      }\n    }\n    graphic {\n      ... on Icon {\n        id\n        description\n        token\n        theme\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesInlineLinkFragment on AffiliatesInlineLink {\n    text\n    action {\n      ...AffiliatesOutwardLinkActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesTextFragment on AffiliatesText {\n    text\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesSpannableTextFragment on AffiliatesSpannableText {\n    inlineContent {\n      ...AffiliatesTextFragment\n      ...AffiliatesInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment CloseToolbarSuccessResponseFragment on AffiliatesCloseToolbarSuccessResponse {\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment CloseToolbarFailureResponseFragment on AffiliatesCloseToolbarFailureResponse {\n    banner {\n      ...EGDSBannerFragment\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  mutation CloseToolbarMutation($context: ContextInput!, $clientContext: AffiliatesClientContextInput!) {\n    closeAffiliateToolbar(context: $context, clientContext: $clientContext) {\n      ...CloseToolbarSuccessResponseFragment\n      ...CloseToolbarFailureResponseFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesSwitchActionFragment on AffiliatesSwitchAction {\n    ... on AffiliatesShowVanityLinkFormAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    ... on AffiliatesShowDescriptiveLinkFormAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    ... on AffiliatesShowCreateTagFormAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesSwitchFragment on AffiliatesSwitch {\n    switch {\n      ... on EGDSStandardSwitch {\n        enabled\n        checked\n        checkedLabel\n        uncheckedLabel\n        checkedDescription\n        uncheckedDescription\n        checkedAccessibilityLabel\n        uncheckedAccessibilityLabel\n      }\n    }\n    onAction {\n      ...AffiliatesSwitchActionFragment\n    }\n    offAction {\n      ...AffiliatesSwitchActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment VanityLinkSuccessFormFragment on AffiliatesCreateVanityLinkSuccessResponse {\n    label\n    copyButton {\n      ... on AffiliatesTransitionButton {\n        defaultButton {\n          ...AffiliatesCopyLinkButtonFragment\n        }\n        transitionButton {\n          ...AffiliatesCopyLinkButtonFragment\n        }\n        transitionInSecs\n        transitionOnRender\n      }\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n    url\n    onloadAction {\n      ... on AffiliatesCopyLinkAction {\n        __typename\n        analytics {\n          ...AffiliatesInteractionAnalyticEventFragment\n        }\n        url\n        toast {\n          text\n          button {\n            primary\n            accessibility\n            disabled\n          }\n        }\n      }\n    }\n    statusMessage {\n      ...AffiliatesIconTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment VanityLinkFailureResponseFragment on AffiliatesCreateVanityLinkFailureResponse {\n    fieldErrors {\n      ... on AffiliatesFieldError {\n        identifier\n        errorMessage {\n          ...AffiliatesSpannableTextFragment\n        }\n      }\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  mutation CreateVanityLinkMutation(\n    $context: ContextInput!\n    $clientContext: AffiliatesClientContextInput!\n    $request: AffiliatesCreateVanityLinkRequestInput!\n  ) {\n    createAffiliateVanityLink(context: $context, clientContext: $clientContext, request: $request) {\n      __typename\n      ...VanityLinkSuccessFormFragment\n      ...VanityLinkFailureResponseFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment VanityLinkFormFragment on AffiliatesVanityLinkForm {\n    pageHandle {\n      ...AffiliatesTextInputFieldFragment\n    }\n    saveButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesVanityLinkSaveAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    cancelButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesCancelAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    serviceFailureError\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment CreateTagFailureResponseFragment on AffiliatesCreateAffiliateTagFailureResponse {\n    fieldErrors {\n      ... on AffiliatesFieldError {\n        identifier\n        errorMessage {\n          ...AffiliatesSpannableTextFragment\n        }\n      }\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment CreateTagSuccessResponseFragment on AffiliatesCreateAffiliateTagSuccessResponse {\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n    switch {\n      ...AffiliatesSwitchFragment\n    }\n    vanityLinkForm {\n      ...VanityLinkFormFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  mutation CreateVanityTagMutation(\n    $context: ContextInput!\n    $clientContext: AffiliatesClientContextInput!\n    $request: AffiliatesCreateAffiliateTagRequestInput!\n  ) {\n    createAffiliateTag(context: $context, clientContext: $clientContext, request: $request) {\n      __typename\n      ...CreateTagFailureResponseFragment\n      ...CreateTagSuccessResponseFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesExampleCustomLinkFragment on AffiliatesCreateTagExampleCustomLink {\n    defaultTag\n    label\n    url\n    tagPlaceholder\n    description {\n      ...AffiliatesSpannableTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesCreateTagFormFragment on AffiliatesCreateTagForm {\n    backButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesBackAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    createTagButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesCreateTagSaveAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    description {\n      ...AffiliatesSpannableTextFragment\n    }\n    tagHandle {\n      ...AffiliatesTextInputFieldFragment\n    }\n    exampleCustomLink {\n      ...AffiliatesExampleCustomLinkFragment\n    }\n    title\n    serviceFailureError\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment DescriptiveLinkFormFragment on AffiliatesDescriptiveLinkForm {\n    label\n    url\n    copyButton {\n      defaultButton {\n        ...AffiliatesCopyLinkButtonFragment\n      }\n      transitionButton {\n        ...AffiliatesCopyLinkButtonFragment\n      }\n      transitionInSecs\n      transitionOnRender\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment ShareToBlogFragment on AffiliatesShareToBlog {\n    title\n    description\n    buttons {\n      ... on AffiliatesShareToBlogButton {\n        mark {\n          ...EGDSMarkFragment\n        }\n        action {\n          ...AffiliatesOutwardLinkActionFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment DefaultLinkSheetContentFragment on AffiliatesCreateLinkDefaultSuccessResponse {\n    closeAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    statsLink {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesViewStatsActionFragment\n      }\n    }\n    pageInfo {\n      ... on AffiliatesPageInfo {\n        pageImage {\n          ...EGDSImageFragment\n        }\n        pageName\n      }\n    }\n    switch {\n      ...AffiliatesSwitchFragment\n    }\n    descriptiveLinkForm {\n      ...DescriptiveLinkFormFragment\n    }\n    createTagForm {\n      ...AffiliatesCreateTagFormFragment\n    }\n    vanityLinkForm {\n      ...VanityLinkFormFragment\n    }\n    statusMessage {\n      ...AffiliatesIconTextFragment\n    }\n    shareToBlog {\n      ...ShareToBlogFragment\n    }\n    onloadAction {\n      ...AffiliatesCopyLinkActionFragment\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment LinkSheetFailureContentFragment on AffiliatesCreateLinkFailureResponse {\n    banner {\n      ...EGDSBannerFragment\n    }\n    closeAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    statsLink {\n      action {\n        ... on AffiliatesViewStatsAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n          unexpectedErrorMessage {\n            ...EGDSBannerFragment\n          }\n        }\n      }\n      disabled\n      subtext\n      text\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesDownloadImagesFragment on AffiliatesDownloadImages {\n    title\n    description {\n      ...AffiliatesSpannableTextFragment\n    }\n    openDownloadImagesGalleryFormButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesShowDownloadImagesGalleryFormAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesDownloadImageButtonFragment on AffiliatesButton {\n    ...AffiliatesButtonFragment\n    action {\n      ... on AffiliatesDownloadImageAction {\n        analytics {\n          ...AffiliatesInteractionAnalyticEventFragment\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesDownloadableImageFragment on AffiliatesDownloadableImage {\n    image {\n      ...EGDSImageFragment\n    }\n    downloadUrl\n    defaultButton {\n      ...AffiliatesDownloadImageButtonFragment\n    }\n    successButton {\n      ...AffiliatesDownloadImageButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesPagingButtonFragment on AffiliatesPagingButton {\n    accessibility\n    disabled\n    iconId\n    iconTitle\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesPaginationFragment on AffiliatesPagination {\n    pageSize\n    prevButton {\n      ...AffiliatesPagingButtonFragment\n      action {\n        ... on AffiliatesPagingPrevAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    nextButton {\n      ...AffiliatesPagingButtonFragment\n      action {\n        ... on AffiliatesPagingNextAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    labelStartPlaceHolder\n    labelEndPlaceHolder\n    label\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesDownloadImagesGalleryFormFragment on AffiliatesDownloadImagesGalleryForm {\n    backButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesBackAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    title\n    description {\n      ...AffiliatesSpannableTextFragment\n    }\n    images {\n      ...AffiliatesDownloadableImageFragment\n    }\n    pagination {\n      ...AffiliatesPaginationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingLinkSheetContentFragment on AffiliatesCreateLinkLodgingSuccessResponse {\n    closeAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    statsLink {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesViewStatsActionFragment\n      }\n    }\n    lodgingInfo {\n      ... on AffiliatesLodgingInfo {\n        propertyImage {\n          ...EGDSImageFragment\n        }\n        propertyName\n      }\n    }\n    switch {\n      ...AffiliatesSwitchFragment\n    }\n    descriptiveLinkForm {\n      ...DescriptiveLinkFormFragment\n    }\n    createTagForm {\n      ...AffiliatesCreateTagFormFragment\n    }\n    vanityLinkForm {\n      ...VanityLinkFormFragment\n    }\n    statusMessage {\n      ...AffiliatesIconTextFragment\n    }\n    downloadImages {\n      ...AffiliatesDownloadImagesFragment\n    }\n    downloadImagesGalleryForm {\n      ...AffiliatesDownloadImagesGalleryFormFragment\n    }\n    shareToBlog {\n      ...ShareToBlogFragment\n    }\n    onloadAction {\n      ...AffiliatesCopyLinkActionFragment\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  mutation CreateLinkMutation($context: ContextInput!, $clientContext: AffiliatesClientContextInput!, $request: AffiliatesCreateLinkRequestInput!) {\n    createAffiliateLink(context: $context, clientContext: $clientContext, request: $request) {\n      ...LodgingLinkSheetContentFragment\n      ...DefaultLinkSheetContentFragment\n      ...LinkSheetFailureContentFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesLodgingCardCarouselItemFragment on AffiliatesLodgingCardCarouselItem {\n    id\n    title\n    subTitle\n    overAllDescription\n    overAllRating\n    reviewsStat\n    image {\n      ...EGDSImageFragment\n    }\n    amenities {\n      ...AffiliatesIconTextFragment\n    }\n    cardLinkAction {\n      ...AffiliatesOutwardLinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment AlternatePropertiesFragment on AffiliatesCarousel {\n    title\n    items {\n      ...AffiliatesLodgingCardCarouselItemFragment\n    }\n    nextButton {\n      accessibility\n      action {\n        ... on AffiliatesPagingNextAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n      disabled\n      iconId\n      iconTitle\n    }\n    previousButton {\n      accessibility\n      action {\n        ... on AffiliatesPagingPrevAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n      disabled\n      iconId\n      iconTitle\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment AvgStayFragment on AffiliatesContent {\n    title\n    subtitle\n    description\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment CommissionInfoFragment on AffiliatesCommissionInfo {\n    avgBookingValue {\n      title\n      value\n    }\n    brandDomain\n    brandLogo {\n      ...EGDSMarkFragment\n    }\n    commissionRate {\n      title\n      value\n    }\n    estimatedCommission {\n      title\n      value\n    }\n    title\n    validityPeriod {\n      title\n      value\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesHighlightedReviewFragment on AffiliatesHighlightedReview {\n    date\n    rating\n    reviewerName\n    text\n    textControl {\n      collapsedAccessibilityText\n      collapsedLabel\n      expanded\n      expandedAccessibilityText\n      expandedLabel\n      items\n      lines\n    }\n    title\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment HighlightedReviewsFragment on AffiliatesHighlightedReviews {\n    criticalReview {\n      ...AffiliatesHighlightedReviewFragment\n    }\n    infoButton {\n      action {\n        ... on AffiliatesShowHighlightedReviewsInfoAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n      button {\n        accessibility\n        disabled\n        icon {\n          ...EGDSIconFragment\n        }\n        primary\n      }\n    }\n    infoDialog {\n      closeButton {\n        action {\n          ... on AffiliatesCloseAction {\n            analytics {\n              ...AffiliatesInteractionAnalyticEventFragment\n            }\n          }\n        }\n        button {\n          accessibility\n          disabled\n          icon {\n            ...EGDSIconFragment\n          }\n          primary\n        }\n        showActionProgress\n      }\n      message {\n        ...AffiliatesSpannableTextFragment\n      }\n    }\n    positiveReview {\n      ...AffiliatesHighlightedReviewFragment\n    }\n    title\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesImageCarouselItemFragment on AffiliatesImageCarouselItem {\n    card {\n      description\n      id\n      image {\n        ...EGDSImageFragment\n      }\n      subTitle\n      title\n    }\n    cardLinkAction {\n      ...AffiliatesOutwardLinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment PopularPlacesToVisitFragment on AffiliatesCarousel {\n    title\n    items {\n      ...AffiliatesImageCarouselItemFragment\n    }\n    nextButton {\n      accessibility\n      action {\n        ... on AffiliatesPagingNextAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n      disabled\n      iconId\n      iconTitle\n    }\n    previousButton {\n      accessibility\n      action {\n        ... on AffiliatesPagingPrevAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n      disabled\n      iconId\n      iconTitle\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment RatingsFragment on AffiliatesRatings {\n    categories {\n      ... on AffiliatesContent {\n        description\n        subtitle\n        title\n      }\n    }\n    grades {\n      ... on EGDSProgressBar {\n        accessibilityLabel\n        percent\n        progressDescription\n        title\n      }\n    }\n    overAllDescription\n    overAllRating\n    title\n  }\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment StatsSheetContentFragment on AffiliatesLodgingStatsSuccessResponse {\n    lodgingInfo {\n      propertyImage {\n        ...EGDSImageFragment\n      }\n      propertyName\n    }\n    commissionInfo {\n      ...CommissionInfoFragment\n    }\n    analyticsInfo {\n      title\n      avgStay {\n        ...AvgStayFragment\n      }\n      guestReviews {\n        ratings {\n          ...RatingsFragment\n        }\n        highlightedReviews {\n          ...HighlightedReviewsFragment\n        }\n      }\n      alternateProperties {\n        ...AlternatePropertiesFragment\n      }\n      popularPlacesToVisit {\n        ...PopularPlacesToVisitFragment\n      }\n    }\n    closeAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n    getLink {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesCreateLinkActionFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment StatsSheetFailureContentFragment on AffiliatesStatsFailureResponse {\n    banner {\n      ...EGDSBannerFragment\n    }\n    closeAction {\n      analytics {\n        ...AffiliatesInteractionAnalyticEventFragment\n      }\n    }\n    getLink {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesCreateLinkActionFragment\n      }\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  query GetStatsQuery($context: ContextInput!, $clientContext: AffiliatesClientContextInput!, $request: AffiliatesStatsRequestInput!) {\n    affiliatesStats(context: $context, clientContext: $clientContext, request: $request) {\n      ...StatsSheetContentFragment\n      ...StatsSheetFailureContentFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesLogoFragment on AffiliatesLogo {\n    mark {\n      ...EGDSMarkFragment\n    }\n    action {\n      ...AffiliatesOutwardLinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesCloseToolbarDialogFragment on AffiliatesCloseToolbarDialog {\n    title\n    content {\n      ...AffiliatesSpannableTextFragment\n    }\n    cancelButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesCancelAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    closeToolbarButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesCloseToolbarAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n          unexpectedErrorMessage {\n            ...EGDSBannerFragment\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesPartnerDetailsFragment on AffiliatesPartnerDetails {\n    name\n    email\n    linkHistory {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesOutwardLinkActionFragment\n      }\n    }\n    account {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesOutwardLinkActionFragment\n      }\n    }\n    help {\n      ...AffiliatesStandardLinkFragment\n      action {\n        ...AffiliatesOutwardLinkActionFragment\n      }\n    }\n    openCloseToolbarDialogButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesOpenCloseToolbarDialogAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    closeToolbarDialog {\n      ...AffiliatesCloseToolbarDialogFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment StripePageLinkButtonFragment on AffiliatesButton {\n    ...AffiliatesButtonFragment\n    action {\n      ...AffiliatesCreateLinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment StripePageStatsButtonFragment on AffiliatesButton {\n    ...AffiliatesButtonFragment\n    action {\n      ...AffiliatesViewStatsActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment AffiliatesStripeSuccessResponseFragment on AffiliatesStripeSuccessResponse {\n    logo {\n      ...AffiliatesLogoFragment\n    }\n    openPartnerDetailsButton {\n      ...AffiliatesButtonFragment\n      action {\n        ... on AffiliatesOpenPartnerDetailsAction {\n          analytics {\n            ...AffiliatesInteractionAnalyticEventFragment\n          }\n        }\n      }\n    }\n    partnerDetails {\n      ...AffiliatesPartnerDetailsFragment\n    }\n    statsButton {\n      ...StripePageStatsButtonFragment\n    }\n    getLinkButton {\n      ...StripePageLinkButtonFragment\n    }\n    impressionAnalytics {\n      ...AffiliatesImpressionAnalyticEventFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  query StripeQuery($context: ContextInput!, $clientContext: AffiliatesClientContextInput!) {\n    affiliatesStripe(context: $context, clientContext: $clientContext) {\n      ...AffiliatesStripeSuccessResponseFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
import { gql as gql18 } from "@apollo/client";
// src/components/common/egds-banner.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
// src/components/common/egds-icon.tsx
import React, { useMemo } from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var fragment = gql(_templateObject());
function toEGDSIconTheme(theme) {
    if (!theme) {
        return void 0;
    }
    return theme;
}
function toEGDSIconSize(size) {
    if (!size) {
        return EGDSIconSize.MEDIUM;
    }
    var _EGDSIconSize_size;
    return (_EGDSIconSize_size = EGDSIconSize[size]) !== null && _EGDSIconSize_size !== void 0 ? _EGDSIconSize_size : EGDSIconSize.MEDIUM;
}
var AffiliatesEGDSIcon = function(param) {
    var _param_data = param.data, id = _param_data.id, description = _param_data.description, token = _param_data.token, theme = _param_data.theme, size = _param_data.size;
    var uitkIconTheme = useMemo(function() {
        return toEGDSIconTheme(theme);
    }, [
        theme
    ]);
    var uitkIconSize = useMemo(function() {
        return toEGDSIconSize(size);
    }, [
        size
    ]);
    return /* @__PURE__ */ React.createElement(EGDSIcon, {
        name: token,
        size: uitkIconSize,
        theme: uitkIconTheme,
        title: description,
        id: id
    });
};
AffiliatesEGDSIcon.displayName = "AffiliatesEGDSIcon";
AffiliatesEGDSIcon.fragment = fragment;
// src/components/common/egds-banner.tsx
var fragment2 = gql2(_templateObject1(), AffiliatesEGDSIcon.fragment);
var AffiliatesEGDSBanner = function(param) {
    var _param_data = param.data, heading = _param_data.heading, message = _param_data.message, icon = _param_data.icon;
    return /* @__PURE__ */ React2.createElement(EGDSBanner, null, /* @__PURE__ */ React2.createElement(EGDSLayoutFlex, {
        alignItems: "center",
        space: "three"
    }, icon && /* @__PURE__ */ React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React2.createElement(EGDSSpacing, {
        padding: {
            inline: "two"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(AffiliatesEGDSIcon, {
        data: icon
    })))), /* @__PURE__ */ React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(EGDSHeading, {
        tag: "h3",
        size: 7
    }, heading), /* @__PURE__ */ React2.createElement(EGDSText, null, message)))));
};
AffiliatesEGDSBanner.displayName = "AffiliatesEGDSBanner";
AffiliatesEGDSBanner.fragment = fragment2;
// src/components/common/egds-image.tsx
import React3, { useMemo as useMemo2 } from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
var fragment3 = gql3(_templateObject2());
function toEGDSFigureRatio(aspectRatio) {
    switch(aspectRatio){
        // NOTE: currently only use THREE_TWO ratio - add more cases when required
        case "THREE_TWO" /* THREE_TWO */ :
        default:
            return EGDSFigureAspectRatioType.R3_2;
    }
}
var AffiliatesEGDSImage = function(param) {
    var children = param.children, _param_data = param.data, description = _param_data.description, url = _param_data.url, aspectRatio = _param_data.aspectRatio;
    var ratio = useMemo2(function() {
        return toEGDSFigureRatio(aspectRatio);
    }, [
        aspectRatio
    ]);
    return /* @__PURE__ */ React3.createElement(EGDSFigure, {
        ratio: ratio,
        roundcorner: true
    }, /* @__PURE__ */ React3.createElement(EGDSImage, {
        placeholderImage: true,
        alt: description,
        src: url
    }), children);
};
AffiliatesEGDSImage.displayName = "AffiliatesEGDSImage";
AffiliatesEGDSImage.fragment = fragment3;
// src/components/common/egds-mark.tsx
import React4, { useMemo as useMemo3 } from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize, EGDSMarkTokenSizesList } from "@egds/react-core/mark";
var fragment4 = gql4(_templateObject3());
function toEGDSMarkOrientation(orientation) {
    switch(orientation){
        // NOTE: currently only use LANDSCAPE orientation - add more cases when required
        case "LANDSCAPE" /* LANDSCAPE */ :
        default:
            return "landscape";
    }
}
function toEGDSMarkSize(size) {
    if (!size) {
        return EGDSMarkSize.MEDIUM;
    }
    if (EGDSMarkSize[size]) {
        return EGDSMarkSize[size];
    }
    var tokenSize = parseInt(size, 10);
    if (Number.isNaN(tokenSize) || !EGDSMarkTokenSizesList[tokenSize]) {
        return EGDSMarkSize.MEDIUM;
    }
    return tokenSize;
}
var AffiliatesEGDSMark = function(param) {
    var _param_data = param.data, id = _param_data.id, description = _param_data.description, orientation = _param_data.orientation, size = _param_data.size, token = _param_data.token, url = _param_data.url;
    var uitkMarkSize = useMemo3(function() {
        return toEGDSMarkSize(size);
    }, [
        size
    ]);
    var uitkMarkOrientation = useMemo3(function() {
        return toEGDSMarkOrientation(orientation);
    }, [
        orientation
    ]);
    if (!token && !(url === null || url === void 0 ? void 0 : url.value)) {
        return null;
    }
    var uitkProps = {
        id: id,
        description: description,
        orientation: uitkMarkOrientation,
        size: uitkMarkSize,
        name: token,
        url: url === null || url === void 0 ? void 0 : url.value
    };
    return /* @__PURE__ */ React4.createElement(EGDSMark, _object_spread({}, uitkProps));
};
AffiliatesEGDSMark.displayName = "AffiliatesEGDSMark";
AffiliatesEGDSMark.fragment = fragment4;
// src/components/common/affiliates-analytics.ts
import { gql as gql5 } from "@apollo/client";
var interactionFragment = gql5(_templateObject4());
var impressionFragment = gql5(_templateObject5());
var AffiliatesAnalytics = {
    interactionFragment: interactionFragment,
    impressionFragment: impressionFragment
};
// src/components/common/affiliates-copy-link-action.ts
import { gql as gql6 } from "@apollo/client";
var fragment5 = gql6(_templateObject6(), AffiliatesAnalytics.interactionFragment);
var AffiliatesCopyLinkAction = {
    fragment: fragment5
};
// src/components/common/affiliates-create-link-action.ts
import { gql as gql7 } from "@apollo/client";
var fragment6 = gql7(_templateObject7(), AffiliatesAnalytics.interactionFragment, AffiliatesEGDSBanner.fragment);
var AffiliatesCreateLinkAction = {
    fragment: fragment6
};
// src/components/common/affiliates-outward-link-action.ts
import { gql as gql8 } from "@apollo/client";
var fragment7 = gql8(_templateObject8(), AffiliatesAnalytics.interactionFragment);
var AffiliatesOutwardLinkAction = {
    fragment: fragment7
};
// src/components/common/affiliates-standard-link.ts
import { gql as gql9 } from "@apollo/client";
var fragment8 = gql9(_templateObject9());
var AffiliatesStandardLink = {
    fragment: fragment8
};
// src/components/common/affiliates-view-stats-action.ts
import { gql as gql10 } from "@apollo/client";
var fragment9 = gql10(_templateObject10(), AffiliatesAnalytics.interactionFragment, AffiliatesEGDSBanner.fragment);
var AffiliatesViewStatsAction = {
    fragment: fragment9
};
// src/components/common/affiliates-text-input-field.ts
import { gql as gql11 } from "@apollo/client";
var requiredValidationFragment = gql11(_templateObject11());
var regexValidationFragment = gql11(_templateObject12());
var fragment10 = gql11(_templateObject13(), requiredValidationFragment, regexValidationFragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesTextInputField = {
    fragment: fragment10
};
// src/components/common/affiliates-button.tsx
import React5, { useCallback } from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSOverlayButton, EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
var fragment11 = gql12(_templateObject14());
var ButtonMapper = {
    UIPrimaryButton: EGDSPrimaryButton,
    UISecondaryButton: EGDSSecondaryButton,
    UITertiaryButton: EGDSTertiaryButton,
    EGDSOverlayButton: EGDSOverlayButton
};
var AffiliatesButton = function(param) {
    var onClickHandler = param.onClickHandler, className = param.className, type = param.type, disabled = param.disabled, inProgress = param.inProgress, _param_data = param.data, button = _param_data.button, showActionProgress = _param_data.showActionProgress;
    var showProgress = showActionProgress && inProgress;
    var handleOnClick = useCallback(function() {
        onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler();
    }, [
        onClickHandler
    ]);
    var iconData = button.icon;
    var buttonProps = {
        onClick: handleOnClick,
        className: className,
        type: type,
        disabled: disabled
    };
    var _ButtonMapper_button___typename;
    var ButtonComponent = (_ButtonMapper_button___typename = ButtonMapper[button.__typename]) !== null && _ButtonMapper_button___typename !== void 0 ? _ButtonMapper_button___typename : EGDSSecondaryButton;
    return /* @__PURE__ */ React5.createElement(ButtonComponent, _object_spread({}, buttonProps), iconData && /* @__PURE__ */ React5.createElement(EGDSIcon2, {
        name: iconData.token,
        size: toEGDSIconSize(iconData.size),
        theme: toEGDSIconTheme(iconData.theme),
        title: iconData.description,
        id: iconData.id
    }), showProgress ? /* @__PURE__ */ React5.createElement(EGDSSpacing2, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(EGDSLoader, {
        isSmall: true,
        isDarkBackground: button.__typename === "UIPrimaryButton"
    }))) : button.primary);
};
AffiliatesButton.displayName = "AffiliatesButton";
AffiliatesButton.fragment = fragment11;
// src/components/common/affiliates-copy-link-button.ts
import { gql as gql13 } from "@apollo/client";
var fragment12 = gql13(_templateObject15(), AffiliatesButton.fragment, AffiliatesCopyLinkAction.fragment);
var AffiliatesCopyLinkButton = {
    fragment: fragment12
};
// src/components/common/affiliates-icon-text.tsx
import React6, { useMemo as useMemo4 } from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment13 = gql14(_templateObject16());
function toEGDSTextSize(size) {
    switch(size){
        // NOTE: currently all AffiliatesIconText.text.size values are null - add more cases when required
        default:
            return 300;
    }
}
function toEGDSTextTheme(theme) {
    switch(theme){
        // NOTE: currently we don't have use cases for other themes aside from POSITIVE and null - add more cases when required
        case "POSITIVE" /* POSITIVE */ :
            return "positive";
        default:
            return "default";
    }
}
function toEGDSTextWeight(weight) {
    switch(weight){
        // NOTE: currently all AffiliatesIconText.text.weight values are null - add more cases when required
        default:
            return void 0;
    }
}
var AffiliatesIconText = function(param) {
    var className = param.className, _param_data = param.data, text = _param_data.text, rawGraphic = _param_data.graphic;
    var textString = text.text;
    var textSize = useMemo4(function() {
        return toEGDSTextSize(text.size);
    }, [
        text.size
    ]);
    var textTheme = useMemo4(function() {
        return toEGDSTextTheme(text.theme);
    }, [
        text.theme
    ]);
    var textWeight = useMemo4(function() {
        return toEGDSTextWeight(text.weight);
    }, [
        text.weight
    ]);
    var graphic = rawGraphic;
    var graphicData = _object_spread_props(_object_spread({}, graphic), {
        size: "EXTRA_SMALL" /* EXTRA_SMALL */ 
    });
    if (!textString) {
        return null;
    }
    return /* @__PURE__ */ React6.createElement(EGDSLayoutFlex2, {
        space: "two",
        className: className,
        alignContent: "center"
    }, graphicData && /* @__PURE__ */ React6.createElement(AffiliatesEGDSIcon, {
        data: graphicData
    }), /* @__PURE__ */ React6.createElement(EGDSText2, {
        size: textSize,
        theme: textTheme,
        weight: textWeight,
        inline: true
    }, textString));
};
AffiliatesIconText.displayName = "AffiliatesIconText";
AffiliatesIconText.fragment = fragment13;
// src/components/common/affiliates-inline-link.tsx
import React7 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
// src/hooks/use-analytics.ts
import { useCallback as useCallback2 } from "react";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// src/utils/clickstream-event-builder-util.ts
var clickstreamEventBuilder = function(analyticEvent) {
    var payload = analyticEvent.payload, eventName = analyticEvent.eventName, eventVersion = analyticEvent.eventVersion, __typename = analyticEvent.__typename;
    try {
        var serverPayload = JSON.parse(payload);
        var allPayloadEventObjects = Object.values(serverPayload.events[eventName]);
        var targetEventObject = allPayloadEventObjects.find(function(eventObject) {
            return eventObject.event_data.event.event_version === eventVersion;
        });
        return targetEventObject.event_data;
    } catch (e) {
        return {
            event: {
                event_name: eventName,
                event_type: __typename,
                event_version: eventVersion
            }
        };
    }
};
// src/utils/client-context-util.ts
var lineOfBusinessDomains = {
    A: "ACTIVITIES" /* ACTIVITIES */ ,
    C: "CAR" /* CAR */ ,
    CR: "CRUISES" /* CRUISES */ ,
    F: "FLIGHT" /* FLIGHT */ ,
    GT: "GROUNDTRANSFERS" /* GROUNDTRANSFERS */ ,
    H: "LODGING" /* LODGING */ ,
    P: "PACKAGES" /* PACKAGES */ ,
    R: "RAILS" /* RAILS */ ,
    U: "UNCLASSIFIED" /* UNCLASSIFIED */ 
};
var pageLocations = {
    0: "SYSTEM" /* SYSTEM */ ,
    10: "ENTRY" /* ENTRY */ ,
    20: "SEARCH_RESULTS" /* SEARCH_RESULTS */ ,
    30: "DETAILS" /* DETAILS */ ,
    40: "CHECKOUT" /* CHECKOUT */ ,
    50: "CHECKOUT_ERROR" /* CHECKOUT_ERROR */ ,
    60: "PAYMENT_ERROR" /* PAYMENT_ERROR */ ,
    70: "CONFIRMATION" /* CONFIRMATION */ ,
    80: "POST_BOOKING" /* POST_BOOKING */ ,
    90: "USER" /* USER */ ,
    500: "FEATURES" /* FEATURES */ 
};
function getClientContext(xPageId) {
    var _xPageId_split_map = _sliced_to_array(xPageId.split(",").map(function(id) {
        return id.trim();
    }), 3), pageId = _xPageId_split_map[0], lineOfBusinessDomainId = _xPageId_split_map[1], pageLocationId = _xPageId_split_map[2];
    var lineOfBusiness = lineOfBusinessDomains[lineOfBusinessDomainId];
    var pageLocation = pageLocations[pageLocationId];
    return {
        pageId: pageId,
        lineOfBusiness: lineOfBusiness,
        pageLocation: pageLocation
    };
}
// src/utils/copy-to-clipboard.ts
var copyToClipboard = function(data) {
    return navigator.clipboard.writeText(data);
};
// src/utils/property-context-util.ts
var bexUrlPathPropertyIdSelector = /\/(?:ho|.*.?h)?(\d+)(?:.*)?(?:\/(?=$))?$/i;
var egUrlParamPropertyIdSelector = "expediaPropertyId";
function getUrlPathPropertyId(url, selector) {
    var _url_pathname_match;
    var _url_pathname_match_;
    return (_url_pathname_match_ = (_url_pathname_match = url.pathname.match(selector)) === null || _url_pathname_match === void 0 ? void 0 : _url_pathname_match[1]) !== null && _url_pathname_match_ !== void 0 ? _url_pathname_match_ : void 0;
}
function getUrlParamPropertyId(url, selector) {
    var _url_searchParams_get;
    return (_url_searchParams_get = url.searchParams.get(selector)) !== null && _url_searchParams_get !== void 0 ? _url_searchParams_get : void 0;
}
function getExpediaPropertyContext(url) {
    return {
        egPropertyId: getUrlPathPropertyId(url, bexUrlPathPropertyIdSelector)
    };
}
function getHotelsPropertyContext(url) {
    return {
        egPropertyId: getUrlParamPropertyId(url, egUrlParamPropertyIdSelector),
        hotelsPropertyId: getUrlPathPropertyId(url, bexUrlPathPropertyIdSelector)
    };
}
function getVrboPropertyContext(url) {
    return {
        egPropertyId: getUrlParamPropertyId(url, egUrlParamPropertyIdSelector)
    };
}
function getWotifPropertyContext(url) {
    return {
        egPropertyId: getUrlPathPropertyId(url, bexUrlPathPropertyIdSelector)
    };
}
function getPropertyContext(targetUrl, site, clientContext) {
    if (targetUrl && clientContext.lineOfBusiness === "LODGING" /* LODGING */  && clientContext.pageLocation === "DETAILS" /* DETAILS */ ) {
        var url = new URL(targetUrl);
        switch(site.brand){
            case "expedia":
                return getExpediaPropertyContext(url);
            case "hotels":
                return getHotelsPropertyContext(url);
            case "vrbo":
                return getVrboPropertyContext(url);
            case "wotif":
                return getWotifPropertyContext(url);
            default:
                return {};
        }
    }
    return {};
}
// src/utils/url-formatter.ts
var urlFormatter = function(url) {
    return url.replace(/(https?:\/\/)?(www\.)?/, "");
};
// src/hooks/use-analytics.ts
var useAnalytics = function() {
    var track = useEgClickstream();
    var trackEvent = useCallback2(function(event) {
        try {
            var clickstreamEvent = clickstreamEventBuilder(event);
            track(clickstreamEvent);
        } catch (e) {}
    }, [
        track
    ]);
    return {
        trackEvent: trackEvent
    };
};
// src/components/common/affiliates-inline-link.tsx
var fragment14 = gql15(_templateObject17(), AffiliatesOutwardLinkAction.fragment);
var AffiliatesInlineLink = function(_param) {
    var _param_data = _param.data, action = _param_data.action, text = _param_data.text, uitkTextProps = _object_without_properties(_param, [
        "data"
    ]);
    var url = action.url, analytics = action.analytics;
    var trackEvent = useAnalytics().trackEvent;
    var handleLinkClick = function() {
        if (analytics) {
            analytics.forEach(trackEvent);
        }
    };
    return /* @__PURE__ */ React7.createElement(EGDSText3, _object_spread_props(_object_spread({}, uitkTextProps), {
        inline: true
    }), /* @__PURE__ */ React7.createElement(EGDSLink, {
        inline: true
    }, /* @__PURE__ */ React7.createElement("a", {
        href: url,
        target: "_blank",
        onClick: handleLinkClick,
        rel: "noopener"
    }, text)));
};
AffiliatesInlineLink.displayName = "AffiliatesInlineLink";
AffiliatesInlineLink.fragment = fragment14;
// src/components/common/affiliates-spannable-text.tsx
import React9 from "react";
import { gql as gql17 } from "@apollo/client";
// src/components/common/affiliates-text.tsx
import React8 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var fragment15 = gql16(_templateObject18());
var AffiliatesText = function(_param) {
    var text = _param.data.text, uitkProps = _object_without_properties(_param, [
        "data"
    ]);
    return /* @__PURE__ */ React8.createElement(EGDSText4, _object_spread({
        inline: true
    }, uitkProps), text);
};
AffiliatesText.displayName = "AffiliatesText";
AffiliatesText.fragment = fragment15;
// src/components/common/affiliates-spannable-text.tsx
var fragment16 = gql17(_templateObject19(), AffiliatesText.fragment, AffiliatesInlineLink.fragment);
var AffiliatesSpannableText = function(_param) {
    var inlineContent = _param.data.inlineContent, uitkTextProps = _object_without_properties(_param, [
        "data"
    ]);
    var components = inlineContent.map(function(el, index) {
        switch(el.__typename){
            case "AffiliatesInlineLink":
                return /* @__PURE__ */ React9.createElement(AffiliatesInlineLink, _object_spread({
                    data: el,
                    key: index
                }, uitkTextProps));
            case "AffiliatesText":
            default:
                return /* @__PURE__ */ React9.createElement(AffiliatesText, _object_spread({
                    data: el,
                    key: index
                }, uitkTextProps));
        }
    });
    return /* @__PURE__ */ React9.createElement("div", null, components);
};
AffiliatesSpannableText.displayName = "AffiliatesSpannableText";
AffiliatesSpannableText.fragment = fragment16;
// src/components/common/sheet-loader.tsx
import React10 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLoader as EGDSLoader2 } from "@egds/react-core/loader";
var SheetLoader = function() {
    return /* @__PURE__ */ React10.createElement(EGDSLayoutFlex3, {
        alignItems: "stretch",
        "data-cy": "sheet-loader"
    }, /* @__PURE__ */ React10.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React10.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: {
            top: "center",
            left: "center"
        }
    }, /* @__PURE__ */ React10.createElement(EGDSLoader2, null))));
};
// src/components/common/sheet-error-content.tsx
import React11 from "react";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
var SheetErrorContent = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React11.createElement(EGDSLayoutPosition2, {
        type: "absolute",
        position: {
            top: "center"
        },
        cloneElement: true
    }, /* @__PURE__ */ React11.createElement(EGDSSpacing3, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(AffiliatesEGDSBanner, {
        data: data
    }))));
};
// src/components/stripe/close-toolbar-mutation.ts
var closeToolbarSuccessResponseFragment = gql18(_templateObject20(), AffiliatesEGDSBanner.fragment, AffiliatesAnalytics.impressionFragment);
var closeToolbarFailureResponseFragment = gql18(_templateObject21(), AffiliatesEGDSBanner.fragment, AffiliatesAnalytics.impressionFragment);
var closeToolbarMutation = gql18(_templateObject22(), closeToolbarSuccessResponseFragment, closeToolbarFailureResponseFragment);
// src/components/stripe/stripe.tsx
import React53, { useMemo as useMemo19 } from "react";
import { gql as gql50, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
// src/contexts/stripe-context.tsx
import React12, { createContext, createRef, useCallback as useCallback3, useContext, useMemo as useMemo5, useState } from "react";
var defaultValue = {
    clientContext: {
        pageId: "",
        pageLocation: "ENTRY" /* ENTRY */ ,
        lineOfBusiness: "UNCLASSIFIED" /* UNCLASSIFIED */ 
    },
    propertyContext: {
        egPropertyId: "",
        hotelsPropertyId: ""
    },
    targetUrl: "",
    linkSheetTriggerRef: createRef(),
    statsSheetTriggerRef: createRef(),
    activeMenu: "NONE" /* NONE */ ,
    activeSheet: "NONE" /* NONE */ ,
    linkSheetContent: {
        type: 0 /* NONE */ 
    },
    statsSheetContent: {
        type: 0 /* NONE */ 
    },
    isToolbarClosed: false,
    setActiveMenu: void 0,
    setActiveSheet: void 0,
    toggleActiveMenu: void 0,
    setLinkSheetContent: void 0,
    setStatsSheetContent: void 0,
    setIsToolbarClosed: void 0
};
var StripeContext = createContext(defaultValue);
var StripeContextProvider = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var linkSheetTriggerRef = defaultValue.linkSheetTriggerRef, statsSheetTriggerRef = defaultValue.statsSheetTriggerRef;
    var _useState = _sliced_to_array(useState(defaultValue.activeMenu), 2), activeMenu = _useState[0], setActiveMenu = _useState[1];
    var _useState1 = _sliced_to_array(useState(defaultValue.activeSheet), 2), activeSheet = _useState1[0], setActiveSheet = _useState1[1];
    var _useState2 = _sliced_to_array(useState(defaultValue.linkSheetContent), 2), linkSheetContent = _useState2[0], setLinkSheetContent = _useState2[1];
    var _useState3 = _sliced_to_array(useState(defaultValue.statsSheetContent), 2), statsSheetContent = _useState3[0], setStatsSheetContent = _useState3[1];
    var _useState4 = _sliced_to_array(useState(defaultValue.isToolbarClosed), 2), isToolbarClosed = _useState4[0], setIsToolbarClosed = _useState4[1];
    var toggleActiveMenu = useCallback3(function(nextActiveMenu) {
        setActiveMenu(function(prevActiveMenu) {
            return prevActiveMenu === nextActiveMenu ? "NONE" /* NONE */  : nextActiveMenu;
        });
    }, []);
    var value = useMemo5(function() {
        return {
            clientContext: props.clientContext,
            propertyContext: props.propertyContext,
            targetUrl: props.targetUrl,
            linkSheetTriggerRef: linkSheetTriggerRef,
            statsSheetTriggerRef: statsSheetTriggerRef,
            activeMenu: activeMenu,
            activeSheet: activeSheet,
            linkSheetContent: linkSheetContent,
            statsSheetContent: statsSheetContent,
            isToolbarClosed: isToolbarClosed,
            setActiveMenu: setActiveMenu,
            setActiveSheet: setActiveSheet,
            toggleActiveMenu: toggleActiveMenu,
            setLinkSheetContent: setLinkSheetContent,
            setStatsSheetContent: setStatsSheetContent,
            setIsToolbarClosed: setIsToolbarClosed
        };
    }, [
        props.clientContext,
        props.propertyContext,
        props.targetUrl,
        linkSheetTriggerRef,
        statsSheetTriggerRef,
        activeMenu,
        activeSheet,
        linkSheetContent,
        statsSheetContent,
        isToolbarClosed,
        toggleActiveMenu
    ]);
    return /* @__PURE__ */ React12.createElement(StripeContext.Provider, {
        value: value
    }, children);
};
var useStripeContext = function() {
    return useContext(StripeContext);
};
// src/components/stripe/affiliates-logo.tsx
import React40, { useCallback as useCallback17 } from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
// src/hooks/use-open-link-sheet.ts
import { useCallback as useCallback11 } from "react";
import { useMutation as useMutation3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// src/components/affiliate-link/link-sheet.tsx
import React31, { useCallback as useCallback10, useEffect as useEffect5 } from "react";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSToolbar, EGDSToolbarButton } from "@egds/react-core/toolbar";
// src/components/affiliate-link/default-link-sheet-content.tsx
import React22, { useState as useState8 } from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSSpacing as EGDSSpacing11, EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
// src/components/affiliate-link/affiliates-switch.tsx
import React13, { useCallback as useCallback4, useMemo as useMemo6 } from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSSwitch } from "@egds/react-core/switch";
var switchActionFragment = gql19(_templateObject23(), AffiliatesAnalytics.interactionFragment);
var fragment17 = gql19(_templateObject24(), switchActionFragment);
var AffiliatesSwitch = function(param) {
    var data = param.data, isChecked = param.isChecked, onToggle = param.onToggle;
    var trackEvent = useAnalytics().trackEvent;
    var egdsSwitch = data.switch, onAction = data.onAction, offAction = data.offAction;
    var enabled = egdsSwitch.enabled, checkedLabel = egdsSwitch.checkedLabel, uncheckedLabel = egdsSwitch.uncheckedLabel, checkedDescription = egdsSwitch.checkedDescription, uncheckedDescription = egdsSwitch.uncheckedDescription, checkedAccessibilityLabel = egdsSwitch.checkedAccessibilityLabel, uncheckedAccessibilityLabel = egdsSwitch.uncheckedAccessibilityLabel;
    var switchDescription = useMemo6(function() {
        var expectedDescription = isChecked ? checkedDescription : uncheckedDescription;
        return expectedDescription !== null && expectedDescription !== void 0 ? expectedDescription : "";
    }, [
        isChecked,
        checkedDescription,
        uncheckedDescription
    ]);
    var switchA11yLabel = useMemo6(function() {
        var expectedA11yLabel = isChecked ? checkedAccessibilityLabel : uncheckedAccessibilityLabel;
        return expectedA11yLabel !== null && expectedA11yLabel !== void 0 ? expectedA11yLabel : "";
    }, [
        isChecked,
        checkedAccessibilityLabel,
        uncheckedAccessibilityLabel
    ]);
    var handleToggle = useCallback4(function() {
        var action = !isChecked ? onAction : offAction;
        onToggle(action);
        action.analytics.forEach(function(event) {
            if (event.__typename === "AffiliatesInteractionAnalyticEvent") {
                trackEvent(event);
            }
        });
    }, [
        isChecked,
        offAction,
        onAction,
        trackEvent,
        onToggle
    ]);
    return /* @__PURE__ */ React13.createElement(EGDSSwitch, {
        id: "affiliates-switch",
        disabled: !enabled,
        checked: isChecked,
        onChange: handleToggle,
        description: switchDescription,
        a11yLabel: switchA11yLabel
    }, isChecked ? checkedLabel : uncheckedLabel);
};
AffiliatesSwitch.displayName = "AffiliatesSwitch";
AffiliatesSwitch.fragment = fragment17;
// src/components/affiliate-link/create-vanity-tag-form.tsx
import React17, { useCallback as useCallback6, useMemo as useMemo9, useState as useState4 } from "react";
import { gql as gql25, useMutation as useMutation2 } from "@apollo/client";
import { EGDSTextInput as EGDSTextInput2 } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { EGDSLoader as EGDSLoader3 } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { classNames } from "@egds/react-core/utils";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/affiliate-link/create-vanity-tag-mutation.ts
import { gql as gql23 } from "@apollo/client";
// src/components/affiliate-link/vanity-link-form.tsx
import React15, { useCallback as useCallback5, useMemo as useMemo8, useState as useState3 } from "react";
import { gql as gql22, useMutation } from "@apollo/client";
import { EGDSTextInput } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex5 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/affiliate-link/create-vanity-link-mutation.ts
import { gql as gql21 } from "@apollo/client";
// src/components/affiliate-link/vanity-link-success-form.tsx
import React14, { useEffect, useMemo as useMemo7, useState as useState2 } from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { EGDSToast } from "@egds/react-core/toast";
var fragment18 = gql20(_templateObject25(), AffiliatesAnalytics.impressionFragment, AffiliatesAnalytics.interactionFragment, AffiliatesIconText.fragment, AffiliatesCopyLinkButton.fragment);
var VanityLinkSuccessForm = function(param) {
    var data = param.data;
    var url = data.url, onloadAction = data.onloadAction, _data_copyButton = data.copyButton, defaultButton = _data_copyButton.defaultButton, transitionButton = _data_copyButton.transitionButton, transitionInSecs = _data_copyButton.transitionInSecs, transitionOnRender = _data_copyButton.transitionOnRender, label = data.label, statusMessage = data.statusMessage;
    var trackEvent = useAnalytics().trackEvent;
    var _useState2 = _sliced_to_array(useState2({
        visible: false,
        message: ""
    }), 2), toastState = _useState2[0], setToastState = _useState2[1];
    var _useState21 = _sliced_to_array(useState2({
        copied: false
    }), 2), buttonState = _useState21[0], setButtonState = _useState21[1];
    var _useState22 = _sliced_to_array(useState2(false), 2), onloadActionTriggered = _useState22[0], setOnloadActionTriggered = _useState22[1];
    var copyButton = useMemo7(function() {
        return buttonState.copied ? transitionButton : defaultButton;
    }, [
        defaultButton,
        transitionButton,
        buttonState
    ]);
    var transitionDuration = useMemo7(function() {
        return transitionInSecs * 1e3;
    }, [
        transitionInSecs
    ]);
    var formattedUrl = useMemo7(function() {
        return urlFormatter(url);
    }, [
        url
    ]);
    useEffect(function() {
        if (!onloadActionTriggered) {
            copyToClipboard(onloadAction.url).then(function() {
                setToastState({
                    visible: true,
                    message: onloadAction.toast.text
                });
                if (transitionOnRender) {
                    setButtonState({
                        copied: true
                    });
                }
            }).finally(function() {
                setOnloadActionTriggered(true);
            });
            var analyticsEvents = onloadAction.analytics;
            analyticsEvents === null || analyticsEvents === void 0 ? void 0 : analyticsEvents.forEach(trackEvent);
        }
    }, [
        onloadAction,
        transitionOnRender,
        onloadActionTriggered,
        trackEvent
    ]);
    useEffect(function() {
        if (toastState.visible) {
            var timeoutRef = setTimeout(function() {
                setToastState({
                    visible: false,
                    message: ""
                });
            }, transitionDuration);
            return function() {
                clearTimeout(timeoutRef);
            };
        }
    }, [
        toastState,
        transitionDuration
    ]);
    useEffect(function() {
        if (buttonState.copied) {
            var timeoutRef = setTimeout(function() {
                setButtonState({
                    copied: false
                });
            }, transitionDuration);
            return function() {
                clearTimeout(timeoutRef);
            };
        }
    }, [
        buttonState,
        transitionDuration
    ]);
    var handleClickToCopy = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(action) {
            var _action_analytics;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(action.__typename === "AffiliatesCopyLinkAction")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            copyToClipboard(action.url)
                        ];
                    case 1:
                        _state.sent();
                        setToastState({
                            visible: true,
                            message: action.toast.text
                        });
                        setButtonState({
                            copied: true
                        });
                        (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.forEach(trackEvent);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickToCopy(action) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, buttonState.copied && /* @__PURE__ */ React14.createElement(EGDSToast, {
        show: toastState.visible,
        verticalOffset: 50
    }, toastState.message), /* @__PURE__ */ React14.createElement(EGDSSpacing4, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(EGDSText5, {
        size: 200
    }, label), /* @__PURE__ */ React14.createElement(EGDSText5, {
        size: 400,
        wordBreak: true
    }, formattedUrl))), /* @__PURE__ */ React14.createElement(EGDSSpacing4, {
        margin: {
            blockstart: "four"
        },
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React14.createElement(EGDSLayoutFlex4, {
        alignContent: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */ React14.createElement(AffiliatesButton, {
        data: copyButton,
        onClickHandler: function() {
            return handleClickToCopy(copyButton.action);
        }
    })), statusMessage && /* @__PURE__ */ React14.createElement(EGDSLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React14.createElement(AffiliatesIconText, {
        data: statusMessage
    })))));
};
VanityLinkSuccessForm.displayName = "VanityLinkSuccessForm";
VanityLinkSuccessForm.fragment = fragment18;
// src/components/affiliate-link/create-vanity-link-mutation.ts
var vanityLinkFailureResponseFragment = gql21(_templateObject26(), AffiliatesSpannableText.fragment, AffiliatesAnalytics.impressionFragment);
var createVanityLinkMutation = gql21(_templateObject27(), AffiliatesButton.fragment, AffiliatesIconText.fragment, VanityLinkSuccessForm.fragment, vanityLinkFailureResponseFragment);
// src/components/affiliate-link/vanity-link-form.tsx
var fragment19 = gql22(_templateObject28(), AffiliatesAnalytics.interactionFragment, AffiliatesButton.fragment, AffiliatesTextInputField.fragment);
var VanityLinkForm = function(param) {
    var data = param.data, onSuccess = param.onSuccess, onCancel = param.onCancel;
    var _data_pageHandle = data.pageHandle, handle = _data_pageHandle.handle, selectionAction = _data_pageHandle.selectionAction, saveButton = data.saveButton, cancelButton = data.cancelButton, serviceFailureError = data.serviceFailureError;
    var _useMutation = _sliced_to_array(useMutation(createVanityLinkMutation), 1), createVanityLink = _useMutation[0];
    var _useStripeContext = useStripeContext(), clientContext = _useStripeContext.clientContext, propertyContext = _useStripeContext.propertyContext, targetUrl = _useStripeContext.targetUrl;
    var context = useBexApi().context;
    var trackEvent = useAnalytics().trackEvent;
    var _useState3 = _sliced_to_array(useState3(false), 2), isSubmitting = _useState3[0], setIsSubmitting = _useState3[1];
    var _useState31 = _sliced_to_array(useState3(""), 2), customUrlValue = _useState31[0], setCustomUrlValue = _useState31[1];
    var _useState32 = _sliced_to_array(useState3(false), 2), customUrlTouched = _useState32[0], setCustomUrlTouched = _useState32[1];
    var _useState33 = _sliced_to_array(useState3(""), 2), customUrlError = _useState33[0], setCustomUrlError = _useState33[1];
    var _useState34 = _sliced_to_array(useState3({}), 2), serverErrorMap = _useState34[0], setServerErrorMap = _useState34[1];
    var elementsMap = useElementsMap([
        {
            key: handle.egdsElementId,
            value: "customUrl"
        }
    ]);
    var isValid = useMemo8(function() {
        return customUrlTouched && !!customUrlValue && !customUrlError;
    }, [
        customUrlTouched,
        customUrlValue,
        customUrlError
    ]);
    var _useFormValidation = useFormValidation(handle.validations), required = _useFormValidation.required, pattern = _useFormValidation.pattern;
    var onSubmit = useCallback5(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var variables, _response_data_createAffiliateVanityLink, _response_data, response, analyticsEvents, mappedServerError, analyticsEvents1, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setIsSubmitting(true);
                        setServerErrorMap({});
                        variables = {
                            context: context,
                            clientContext: clientContext,
                            request: {
                                targetUrl: targetUrl,
                                propertyContext: propertyContext,
                                userText: customUrlValue
                            }
                        };
                        if (data.saveButton.action.__typename === "AffiliatesVanityLinkSaveAction") {
                            data.saveButton.action.analytics.forEach(trackEvent);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            createVanityLink({
                                variables: variables
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        switch((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_createAffiliateVanityLink = _response_data.createAffiliateVanityLink) === null || _response_data_createAffiliateVanityLink === void 0 ? void 0 : _response_data_createAffiliateVanityLink.__typename){
                            case "AffiliatesCreateVanityLinkSuccessResponse":
                                {
                                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data.createAffiliateVanityLink);
                                    analyticsEvents = response.data.createAffiliateVanityLink.impressionAnalytics;
                                    analyticsEvents.forEach(trackEvent);
                                    return [
                                        2
                                    ];
                                }
                            case "AffiliatesCreateVanityLinkFailureResponse":
                                {
                                    mappedServerError = response.data.createAffiliateVanityLink.fieldErrors.reduce(function(result, fieldError) {
                                        var targetFieldName = elementsMap[fieldError.identifier];
                                        return _object_spread({}, result, targetFieldName ? _define_property({}, targetFieldName, fieldError.errorMessage) : {});
                                    }, {});
                                    setServerErrorMap(function(prevState) {
                                        return _object_spread({}, prevState, mappedServerError);
                                    });
                                    analyticsEvents1 = response.data.createAffiliateVanityLink.impressionAnalytics;
                                    analyticsEvents1.forEach(trackEvent);
                                    return [
                                        2
                                    ];
                                }
                            default:
                                throw new Error("Unable to handle response");
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        if (serviceFailureError) {
                            setServerErrorMap(function(prevState) {
                                return _object_spread_props(_object_spread({}, prevState), {
                                    customUrl: {
                                        __typename: "AffiliatesSpannableText",
                                        inlineContent: [
                                            {
                                                __typename: "AffiliatesText",
                                                text: serviceFailureError
                                            }
                                        ]
                                    }
                                });
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        context,
        clientContext,
        targetUrl,
        propertyContext,
        customUrlValue,
        createVanityLink,
        onSuccess,
        trackEvent,
        elementsMap,
        serviceFailureError,
        data.saveButton
    ]);
    var validateHandleInput = useCallback5(function(handleInput) {
        if (!handleInput && !!required) {
            setCustomUrlError(required);
            return;
        }
        if (!!handleInput && !!pattern && !pattern.value.test(handleInput)) {
            setCustomUrlError(pattern.message);
            return;
        }
        setCustomUrlError("");
    }, [
        required,
        pattern
    ]);
    var handleChange = useCallback5(function(nextCustomUrlValue) {
        var lowerCaseValue = nextCustomUrlValue.toLowerCase();
        validateHandleInput(lowerCaseValue);
        setCustomUrlValue(lowerCaseValue);
    }, [
        validateHandleInput
    ]);
    var handleBlur = useCallback5(function() {
        validateHandleInput(customUrlValue);
    }, [
        customUrlValue,
        validateHandleInput
    ]);
    var handleCancel = useCallback5(function() {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        if (cancelButton.action.__typename === "AffiliatesCancelAction") {
            cancelButton.action.analytics.forEach(trackEvent);
        }
    }, [
        onCancel,
        cancelButton.action,
        trackEvent
    ]);
    return /* @__PURE__ */ React15.createElement("form", {
        id: "vanity-link-form",
        onSubmit: onSubmit
    }, /* @__PURE__ */ React15.createElement(EGDSTextInput, {
        id: "customUrl",
        placeholder: handle.placeholder || " ",
        label: urlFormatter(handle.label),
        name: "customUrl",
        value: customUrlValue,
        onFocus: function() {
            setCustomUrlTouched(true);
            selectionAction.analytics.forEach(trackEvent);
        },
        onChange: function(e) {
            setServerErrorMap(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    customUrl: void 0
                });
            });
            handleChange(e.target.value);
        },
        onBlur: handleBlur,
        invalid: customUrlError,
        hasClearButton: true,
        required: true
    }), serverErrorMap.customUrl && /* @__PURE__ */ React15.createElement("div", {
        className: "uitk-field-message uitk-field-message-error uitk-error-message"
    }, /* @__PURE__ */ React15.createElement(AffiliatesSpannableText, {
        data: serverErrorMap.customUrl,
        theme: "negative",
        size: 200
    })), /* @__PURE__ */ React15.createElement(EGDSSpacing5, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React15.createElement(EGDSLayoutFlex5, {
        alignItems: "center"
    }, /* @__PURE__ */ React15.createElement(AffiliatesButton, {
        data: saveButton,
        inProgress: isSubmitting,
        disabled: !isValid || isSubmitting,
        type: "submit"
    }), /* @__PURE__ */ React15.createElement(EGDSSpacing5, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React15.createElement(AffiliatesButton, {
        data: cancelButton,
        onClickHandler: handleCancel
    })))));
};
VanityLinkForm.displayName = "VanityLinkForm";
VanityLinkForm.fragment = fragment19;
// src/components/affiliate-link/create-vanity-tag-mutation.ts
var createTagFailureResponseFragment = gql23(_templateObject29(), AffiliatesSpannableText.fragment, AffiliatesAnalytics.impressionFragment);
var createTagSuccessResponseFragment = gql23(_templateObject30(), AffiliatesAnalytics.impressionFragment, AffiliatesSwitch.fragment, VanityLinkForm.fragment);
var createVanityTagMutation = gql23(_templateObject31(), createTagFailureResponseFragment, createTagSuccessResponseFragment);
// src/components/affiliate-link/example-custom-link.tsx
import React16 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var fragment20 = gql24(_templateObject32(), AffiliatesSpannableText.fragment);
var AffiliatesExampleCustomLink = function(param) {
    var _param_data = param.data, label = _param_data.label, url = _param_data.url, tagPlaceholder = _param_data.tagPlaceholder, description = _param_data.description, vanityTagHandle = param.vanityTagHandle;
    var modifiedUrl = urlFormatter(url).split("".concat(tagPlaceholder));
    return /* @__PURE__ */ React16.createElement(EGDSCard, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React16.createElement("section", null, /* @__PURE__ */ React16.createElement(EGDSCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React16.createElement(EGDSSpacing6, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React16.createElement(AffiliatesSpannableText, {
        data: description
    })), /* @__PURE__ */ React16.createElement(EGDSSpacing6, {
        padding: {
            block: "two",
            inline: "three"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(EGDSText6, {
        size: 200
    }, label), /* @__PURE__ */ React16.createElement(EGDSText6, {
        overflow: "wrap"
    }, /* @__PURE__ */ React16.createElement(EGDSText6, {
        size: 400,
        weight: "regular",
        inline: true
    }, modifiedUrl[0]), /* @__PURE__ */ React16.createElement(EGDSText6, {
        size: 400,
        weight: "medium",
        inline: "strong"
    }, vanityTagHandle || " ... "), /* @__PURE__ */ React16.createElement(EGDSText6, {
        size: 400,
        weight: "regular",
        inline: true
    }, modifiedUrl[1])))))));
};
AffiliatesExampleCustomLink.displayName = "AffiliatesCreateTagExampleCustomLink";
AffiliatesExampleCustomLink.fragment = fragment20;
// src/components/affiliate-link/create-vanity-tag-form.tsx
var fragment21 = gql25(_templateObject33(), AffiliatesAnalytics.interactionFragment, AffiliatesButton.fragment, AffiliatesSpannableText.fragment, AffiliatesTextInputField.fragment, AffiliatesExampleCustomLink.fragment);
var CreateVanityTagForm = function(param) {
    var data = param.data, onSuccess = param.onSuccess, onCancel = param.onCancel;
    var context = useBexApi2().context;
    var clientContext = useStripeContext().clientContext;
    var trackEvent = useAnalytics().trackEvent;
    var backButton = data.backButton, createTagButton = data.createTagButton, description = data.description, _data_tagHandle = data.tagHandle, handle = _data_tagHandle.handle, selectionAction = _data_tagHandle.selectionAction, exampleCustomLink = data.exampleCustomLink, title = data.title, serviceFailureError = data.serviceFailureError;
    var _useFormValidation = useFormValidation(handle.validations), required = _useFormValidation.required, pattern = _useFormValidation.pattern;
    var _useMutation2 = _sliced_to_array(useMutation2(createVanityTagMutation), 1), createVanityTag = _useMutation2[0];
    var formatVanityHandleInput = useCallback6(function(handleInput) {
        return handleInput.toLowerCase().replace(/\s/g, "");
    }, []);
    var _useState4 = _sliced_to_array(useState4(formatVanityHandleInput(exampleCustomLink.defaultTag || "")), 2), vanityTag = _useState4[0], setVanityTag = _useState4[1];
    var _useState41 = _sliced_to_array(useState4(""), 2), vanityTagError = _useState41[0], setVanityTagError = _useState41[1];
    var _useState42 = _sliced_to_array(useState4({}), 2), serverErrors = _useState42[0], setServerErrors = _useState42[1];
    var _useState43 = _sliced_to_array(useState4(false), 2), isSubmitting = _useState43[0], setIsSubmitting = _useState43[1];
    var isValid = useMemo9(function() {
        return !!vanityTag && !vanityTagError;
    }, [
        vanityTagError,
        vanityTag
    ]);
    var elementsMap = useElementsMap([
        {
            key: handle.egdsElementId,
            value: "vanityTag"
        }
    ]);
    var handleSubmit = useCallback6(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var variables, _response_data_createAffiliateTag, _response_data, response, mappedServerError, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setIsSubmitting(true);
                        setServerErrors({});
                        variables = {
                            context: context,
                            clientContext: clientContext,
                            request: {
                                userText: vanityTag
                            }
                        };
                        if (createTagButton.action.__typename === "AffiliatesCreateTagSaveAction") {
                            createTagButton.action.analytics.forEach(trackEvent);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            createVanityTag({
                                variables: variables
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        switch((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_createAffiliateTag = _response_data.createAffiliateTag) === null || _response_data_createAffiliateTag === void 0 ? void 0 : _response_data_createAffiliateTag.__typename){
                            case "AffiliatesCreateAffiliateTagSuccessResponse":
                                {
                                    response.data.createAffiliateTag.impressionAnalytics.forEach(trackEvent);
                                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data.createAffiliateTag);
                                    return [
                                        2
                                    ];
                                }
                            case "AffiliatesCreateAffiliateTagFailureResponse":
                                {
                                    response.data.createAffiliateTag.impressionAnalytics.forEach(trackEvent);
                                    mappedServerError = response.data.createAffiliateTag.fieldErrors.reduce(function(result, fieldError) {
                                        var targetFieldName = elementsMap[fieldError.identifier];
                                        return _object_spread({}, result, targetFieldName ? _define_property({}, targetFieldName, fieldError.errorMessage) : {});
                                    }, {});
                                    setServerErrors(function(prevState) {
                                        return _object_spread({}, prevState, mappedServerError);
                                    });
                                    return [
                                        2
                                    ];
                                }
                            default:
                                {
                                    throw new Error("Unable to handle response");
                                }
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        if (serviceFailureError) {
                            setServerErrors(function(prevState) {
                                return _object_spread_props(_object_spread({}, prevState), {
                                    vanityTag: {
                                        __typename: "AffiliatesSpannableText",
                                        inlineContent: [
                                            {
                                                __typename: "AffiliatesText",
                                                text: serviceFailureError
                                            }
                                        ]
                                    }
                                });
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        clientContext,
        context,
        createTagButton,
        createVanityTag,
        elementsMap,
        onSuccess,
        serviceFailureError,
        trackEvent,
        vanityTag
    ]);
    var validateVanityHandleInput = useCallback6(function(handleInput) {
        if (!handleInput && !!required) {
            setVanityTagError(required);
            return;
        }
        if (!!handleInput && !!pattern && !pattern.value.test(handleInput)) {
            setVanityTagError(pattern.message);
            return;
        }
        setVanityTagError("");
    }, [
        required,
        pattern
    ]);
    var handleFocus = useCallback6(function() {
        selectionAction.analytics.forEach(trackEvent);
    }, [
        selectionAction.analytics,
        trackEvent
    ]);
    var handleChange = useCallback6(function(event) {
        setServerErrors(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), {
                vanityTag: void 0
            });
        });
        var formattedVanityTag = formatVanityHandleInput(event.target.value);
        validateVanityHandleInput(formattedVanityTag);
        setVanityTag(formattedVanityTag);
        if (formattedVanityTag !== event.target.value && event.target.selectionStart !== null) {
            var _event_persist;
            var caretPosition = event.target.selectionStart - (event.target.value.length - formattedVanityTag.length);
            (_event_persist = event.persist) === null || _event_persist === void 0 ? void 0 : _event_persist.call(event);
            setTimeout(function() {
                var _event_target;
                (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.setSelectionRange(caretPosition, caretPosition);
            });
        }
    }, [
        formatVanityHandleInput,
        validateVanityHandleInput
    ]);
    var handleBlur = useCallback6(function() {
        validateVanityHandleInput(vanityTag);
    }, [
        validateVanityHandleInput,
        vanityTag
    ]);
    var handleCancel = useCallback6(function() {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        if (backButton.action.__typename === "AffiliatesBackAction") {
            backButton.action.analytics.forEach(trackEvent);
        }
    }, [
        onCancel,
        backButton.action,
        trackEvent
    ]);
    return /* @__PURE__ */ React17.createElement(EGDSLayoutPosition3, {
        type: "relative"
    }, /* @__PURE__ */ React17.createElement("form", {
        id: "create-tag-form",
        className: classNames({
            "is-disabled": isSubmitting
        }),
        onSubmit: handleSubmit
    }, /* @__PURE__ */ React17.createElement(AffiliatesButton, {
        data: backButton,
        onClickHandler: handleCancel
    }), /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(EGDSHeading2, {
        tag: "h3",
        size: 6
    }, title), description.map(function(desc, index) {
        return /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
            margin: {
                blockstart: "two"
            },
            key: index
        }, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(AffiliatesSpannableText, {
            data: desc
        })));
    }))), /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(EGDSTextInput2, {
        id: "vanityTag",
        name: "vanityTag",
        label: handle.label,
        value: vanityTag,
        placeholder: handle.placeholder || " ",
        invalid: vanityTagError,
        required: true,
        hasClearButton: true,
        onFocus: handleFocus,
        onChange: handleChange,
        onBlur: handleBlur
    }), serverErrors.vanityTag && /* @__PURE__ */ React17.createElement("div", {
        className: "uitk-field-message uitk-field-message-error uitk-error-message"
    }, /* @__PURE__ */ React17.createElement(AffiliatesSpannableText, {
        data: serverErrors.vanityTag,
        size: 200,
        theme: "negative"
    })))), /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(AffiliatesExampleCustomLink, {
        vanityTagHandle: vanityTag,
        data: exampleCustomLink
    }))), /* @__PURE__ */ React17.createElement(EGDSSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React17.createElement(EGDSLayoutFlex6, {
        space: "three",
        alignItems: "center"
    }, /* @__PURE__ */ React17.createElement(AffiliatesButton, {
        data: createTagButton,
        type: "submit",
        disabled: !isValid || isSubmitting
    }))), isSubmitting && /* @__PURE__ */ React17.createElement(EGDSLayoutPosition3, {
        type: "absolute",
        position: {
            top: "center",
            left: "center"
        }
    }, /* @__PURE__ */ React17.createElement(EGDSLoader3, null))));
};
CreateVanityTagForm.displayName = "CreateVanityTagForm";
CreateVanityTagForm.fragment = fragment21;
// src/components/affiliate-link/descriptive-link-form.tsx
import React19, { useEffect as useEffect2, useMemo as useMemo11, useState as useState6 } from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { EGDSToast as EGDSToast2 } from "@egds/react-core/toast";
// src/components/affiliate-link/link-form-context.tsx
import React18, { createContext as createContext2, useContext as useContext2, useMemo as useMemo10, useState as useState5 } from "react";
var defaultValue2 = {
    descriptiveOnloadActionTriggered: false,
    setDescriptiveOnloadActionTriggered: void 0
};
var LinkFormContext = createContext2(defaultValue2);
var LinkFormContextProvider = function(param) {
    var children = param.children;
    var _useState5 = _sliced_to_array(useState5(defaultValue2.descriptiveOnloadActionTriggered), 2), descriptiveOnloadActionTriggered = _useState5[0], setDescriptiveOnloadActionTriggered = _useState5[1];
    var value = useMemo10(function() {
        return {
            descriptiveOnloadActionTriggered: descriptiveOnloadActionTriggered,
            setDescriptiveOnloadActionTriggered: setDescriptiveOnloadActionTriggered
        };
    }, [
        descriptiveOnloadActionTriggered
    ]);
    return /* @__PURE__ */ React18.createElement(LinkFormContext.Provider, {
        value: value
    }, children);
};
var useLinkFormContext = function() {
    return useContext2(LinkFormContext);
};
// src/components/affiliate-link/descriptive-link-form.tsx
var fragment22 = gql26(_templateObject34(), AffiliatesCopyLinkButton.fragment);
var DescriptiveLinkForm = function(param) {
    var _param_data = param.data, label = _param_data.label, url = _param_data.url, _param_data_copyButton = _param_data.copyButton, defaultButton = _param_data_copyButton.defaultButton, transitionButton = _param_data_copyButton.transitionButton, transitionInSecs = _param_data_copyButton.transitionInSecs, transitionOnRender = _param_data_copyButton.transitionOnRender, statusMessage = param.statusMessage, onloadAction = param.onloadAction;
    var trackEvent = useAnalytics().trackEvent;
    var _useLinkFormContext = useLinkFormContext(), descriptiveOnloadActionTriggered = _useLinkFormContext.descriptiveOnloadActionTriggered, setDescriptiveOnloadActionTriggered = _useLinkFormContext.setDescriptiveOnloadActionTriggered;
    var _useState6 = _sliced_to_array(useState6({
        visible: false,
        message: ""
    }), 2), toastState = _useState6[0], setToastState = _useState6[1];
    var _useState61 = _sliced_to_array(useState6({
        copied: false
    }), 2), buttonState = _useState61[0], setButtonState = _useState61[1];
    var copyButton = useMemo11(function() {
        return buttonState.copied ? transitionButton : defaultButton;
    }, [
        defaultButton,
        transitionButton,
        buttonState
    ]);
    var transitionDuration = useMemo11(function() {
        return transitionInSecs * 1e3;
    }, [
        transitionInSecs
    ]);
    var formattedUrl = useMemo11(function() {
        return urlFormatter(url);
    }, [
        url
    ]);
    useEffect2(function() {
        if (!descriptiveOnloadActionTriggered) {
            copyToClipboard(onloadAction.url).then(function() {
                setToastState({
                    visible: true,
                    message: onloadAction.toast.text
                });
                if (transitionOnRender) {
                    setButtonState({
                        copied: true
                    });
                }
            }).finally(function() {
                setDescriptiveOnloadActionTriggered === null || setDescriptiveOnloadActionTriggered === void 0 ? void 0 : setDescriptiveOnloadActionTriggered(true);
            });
            onloadAction.analytics.forEach(trackEvent);
        }
    }, [
        onloadAction,
        transitionOnRender,
        descriptiveOnloadActionTriggered,
        setDescriptiveOnloadActionTriggered,
        trackEvent
    ]);
    useEffect2(function() {
        if (toastState.visible) {
            var timeoutRef = setTimeout(function() {
                setToastState({
                    visible: false,
                    message: ""
                });
            }, transitionDuration);
            return function() {
                clearTimeout(timeoutRef);
            };
        }
    }, [
        toastState,
        transitionDuration
    ]);
    useEffect2(function() {
        if (buttonState.copied) {
            var timeoutRef = setTimeout(function() {
                setButtonState({
                    copied: false
                });
            }, transitionDuration);
            return function() {
                clearTimeout(timeoutRef);
            };
        }
    }, [
        buttonState,
        transitionDuration
    ]);
    var handleClickToCopy = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(action) {
            var _action_analytics;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(action.__typename === "AffiliatesCopyLinkAction")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            copyToClipboard(action.url)
                        ];
                    case 1:
                        _state.sent();
                        setToastState({
                            visible: true,
                            message: action.toast.text
                        });
                        setButtonState({
                            copied: true
                        });
                        (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.forEach(trackEvent);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickToCopy(action) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, buttonState.copied && /* @__PURE__ */ React19.createElement(EGDSToast2, {
        show: toastState.visible,
        verticalOffset: 50
    }, toastState.message), /* @__PURE__ */ React19.createElement(EGDSText7, {
        size: 200
    }, label), /* @__PURE__ */ React19.createElement(EGDSText7, {
        size: 400,
        wordBreak: true
    }, formattedUrl), /* @__PURE__ */ React19.createElement(EGDSSpacing8, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React19.createElement(EGDSLayoutFlex7, {
        alignContent: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React19.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(AffiliatesButton, {
        data: copyButton,
        onClickHandler: function() {
            return handleClickToCopy(copyButton.action);
        }
    })), statusMessage && /* @__PURE__ */ React19.createElement(EGDSLayoutFlexItem4, {
        alignSelf: "center"
    }, /* @__PURE__ */ React19.createElement(AffiliatesIconText, {
        data: statusMessage
    })))));
};
DescriptiveLinkForm.displayName = "DescriptiveLinkForm";
DescriptiveLinkForm.fragment = fragment22;
// src/components/affiliate-link/link-form-section.tsx
import React20, { useCallback as useCallback7, useEffect as useEffect3, useMemo as useMemo12, useState as useState7 } from "react";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
var LinkFormSection = function(param) {
    var data = param.data, onFormChange = param.onFormChange;
    var _useState7 = _sliced_to_array(useState7(0 /* DESCRIPTIVE */ ), 2), formType = _useState7[0], setFormType = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(), 2), createVanityLinkSuccessResponse = _useState71[0], setCreateVanityLinkSuccessResponse = _useState71[1];
    var _useState72 = _sliced_to_array(useState7(data.vanityLinkForm), 2), vanityLinkFormData = _useState72[0], setVanityLinkFormData = _useState72[1];
    var _useState73 = _sliced_to_array(useState7(data.switch), 2), switchData = _useState73[0], setSwitchData = _useState73[1];
    var isSwitchChecked = useMemo12(function() {
        return formType !== 0 /* DESCRIPTIVE */ ;
    }, [
        formType
    ]);
    var handleOnToggleSwitch = function(action) {
        if (action.__typename === "AffiliatesShowVanityLinkFormAction") {
            setFormType(2 /* VANITY_CREATE */ );
        } else if (action.__typename === "AffiliatesShowDescriptiveLinkFormAction") {
            setFormType(0 /* DESCRIPTIVE */ );
        } else if (action.__typename === "AffiliatesShowCreateTagFormAction") {
            setFormType(1 /* TAG_CREATE */ );
        }
    };
    var handleVanityTagFormSuccess = useCallback7(function(response) {
        setVanityLinkFormData(response.vanityLinkForm);
        setSwitchData(response.switch);
        setFormType(2 /* VANITY_CREATE */ );
    }, []);
    var handleVanityLinkFormSuccess = function(response) {
        setCreateVanityLinkSuccessResponse(response);
        setFormType(3 /* VANITY_SUCCESS */ );
    };
    useEffect3(function() {
        onFormChange === null || onFormChange === void 0 ? void 0 : onFormChange(formType);
    }, [
        formType,
        onFormChange
    ]);
    return /* @__PURE__ */ React20.createElement(LinkFormContextProvider, null, !!switchData && formType !== 1 /* TAG_CREATE */  && /* @__PURE__ */ React20.createElement(AffiliatesSwitch, {
        data: switchData,
        isChecked: isSwitchChecked,
        onToggle: handleOnToggleSwitch
    }), formType === 0 /* DESCRIPTIVE */  && /* @__PURE__ */ React20.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(DescriptiveLinkForm, {
        data: data.descriptiveLinkForm,
        onloadAction: data.onloadAction,
        statusMessage: data.statusMessage
    }))), formType === 1 /* TAG_CREATE */  && !!data.createTagForm && /* @__PURE__ */ React20.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(CreateVanityTagForm, {
        data: data.createTagForm,
        onCancel: function() {
            return setFormType(0 /* DESCRIPTIVE */ );
        },
        onSuccess: handleVanityTagFormSuccess
    }))), formType === 2 /* VANITY_CREATE */  && !!vanityLinkFormData && /* @__PURE__ */ React20.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(VanityLinkForm, {
        data: vanityLinkFormData,
        onCancel: function() {
            return setFormType(0 /* DESCRIPTIVE */ );
        },
        onSuccess: handleVanityLinkFormSuccess
    }))), formType === 3 /* VANITY_SUCCESS */  && createVanityLinkSuccessResponse && /* @__PURE__ */ React20.createElement(EGDSSpacing9, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(VanityLinkSuccessForm, {
        data: createVanityLinkSuccessResponse
    }))));
};
// src/components/affiliate-link/share-to-blog.tsx
import React21 from "react";
import { gql as gql27 } from "@apollo/client";
import { EGDSButtonSize, EGDSExternalButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex8 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText8 } from "@egds/react-core/text";
var fragment23 = gql27(_templateObject35(), AffiliatesOutwardLinkAction.fragment, AffiliatesEGDSMark.fragment);
var ShareToBlog = function(param) {
    var data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function(analyticsEvents) {
        analyticsEvents.forEach(trackEvent);
    };
    var blogIcons = data.buttons.map(function(button) {
        return /* @__PURE__ */ React21.createElement(EGDSExternalButton, {
            key: button.action.url,
            href: button.action.url,
            tag: "a",
            target: "_blank",
            onClick: function() {
                return handleClick(button.action.analytics);
            },
            size: EGDSButtonSize.SMALL
        }, /* @__PURE__ */ React21.createElement(AffiliatesEGDSMark, {
            data: _object_spread_props(_object_spread({}, button.mark), {
                size: "7"
            })
        }));
    });
    return /* @__PURE__ */ React21.createElement("div", {
        "data-cy": "share-to-blog-section"
    }, /* @__PURE__ */ React21.createElement(EGDSSpacing10, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React21.createElement(EGDSHeading3, {
        tag: "h3",
        size: 6
    }, data.title)), /* @__PURE__ */ React21.createElement(EGDSSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React21.createElement(EGDSText8, null, data.description)), /* @__PURE__ */ React21.createElement(EGDSSpacing10, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React21.createElement(EGDSLayoutFlex8, {
        space: "six",
        wrap: "wrap"
    }, blogIcons)));
};
ShareToBlog.displayName = "ShareToBlog";
ShareToBlog.fragment = fragment23;
// src/components/affiliate-link/default-link-sheet-content.tsx
var fragment24 = gql28(_templateObject36(), AffiliatesAnalytics.interactionFragment, AffiliatesAnalytics.impressionFragment, AffiliatesStandardLink.fragment, AffiliatesEGDSImage.fragment, AffiliatesSwitch.fragment, VanityLinkForm.fragment, AffiliatesIconText.fragment, ShareToBlog.fragment, DescriptiveLinkForm.fragment, AffiliatesCopyLinkAction.fragment, AffiliatesViewStatsAction.fragment, CreateVanityTagForm.fragment);
var DefaultLinkSheetContent = function(param) {
    var data = param.data;
    var _data_pageInfo_pageImage, _data_pageInfo, _data_pageInfo_pageImage1, _data_pageInfo1, _data_pageInfo2;
    var _useState8 = _sliced_to_array(useState8(true), 2), showPageName = _useState8[0], setShowPageName = _useState8[1];
    var _useState81 = _sliced_to_array(useState8(true), 2), showShareToBlog = _useState81[0], setShowShareToBlog = _useState81[1];
    var hasShareToBlogSection = !!data.shareToBlog && showShareToBlog;
    var handleFormChange = function(formType) {
        switch(formType){
            case 1 /* TAG_CREATE */ :
                setShowShareToBlog(false);
                setShowPageName(false);
                break;
            case 0 /* DESCRIPTIVE */ :
            case 2 /* VANITY_CREATE */ :
            case 3 /* VANITY_SUCCESS */ :
            default:
                setShowShareToBlog(true);
                setShowPageName(true);
                break;
        }
    };
    return /* @__PURE__ */ React22.createElement(EGDSSpacing11, {
        padding: {
            blockend: "twelve"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(EGDSFigure2, {
        ratio: EGDSFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React22.createElement(EGDSImage2, {
        placeholderImage: true,
        alt: (_data_pageInfo = data.pageInfo) === null || _data_pageInfo === void 0 ? void 0 : (_data_pageInfo_pageImage = _data_pageInfo.pageImage) === null || _data_pageInfo_pageImage === void 0 ? void 0 : _data_pageInfo_pageImage.description,
        src: (_data_pageInfo1 = data.pageInfo) === null || _data_pageInfo1 === void 0 ? void 0 : (_data_pageInfo_pageImage1 = _data_pageInfo1.pageImage) === null || _data_pageInfo_pageImage1 === void 0 ? void 0 : _data_pageInfo_pageImage1.url
    })), showPageName && ((_data_pageInfo2 = data.pageInfo) === null || _data_pageInfo2 === void 0 ? void 0 : _data_pageInfo2.pageName) && /* @__PURE__ */ React22.createElement(EGDSSpacing11, {
        margin: {
            inline: "six",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React22.createElement(EGDSHeading4, {
        tag: "h2",
        size: 5
    }, data.pageInfo.pageName)), /* @__PURE__ */ React22.createElement(EGDSSpacing11, {
        margin: {
            blockstart: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(LinkFormSection, {
        data: data,
        onFormChange: handleFormChange
    }))), hasShareToBlogSection && /* @__PURE__ */ React22.createElement(EGDSSpacingHr, {
        blockMargin: "twelve"
    }), hasShareToBlogSection && /* @__PURE__ */ React22.createElement(EGDSSpacing11, {
        margin: {
            blockstart: "twelve",
            inline: "six"
        }
    }, /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement(ShareToBlog, {
        data: data.shareToBlog
    })))));
};
DefaultLinkSheetContent.displayName = "DefaultLinkSheet";
DefaultLinkSheetContent.fragment = fragment24;
// src/components/affiliate-link/link-sheet-failure-content.tsx
import React23 from "react";
import { gql as gql29 } from "@apollo/client";
var fragment25 = gql29(_templateObject37(), AffiliatesEGDSBanner.fragment, AffiliatesAnalytics.impressionFragment, AffiliatesAnalytics.interactionFragment);
var LinkSheetFailureContent = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React23.createElement(SheetErrorContent, {
        data: data.banner
    });
};
LinkSheetFailureContent.displayName = "LinkSheetFailureContent";
LinkSheetFailureContent.fragment = fragment25;
// src/components/affiliate-link/lodging-link-sheet-content.tsx
import React30, { useState as useState13 } from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSSpacing as EGDSSpacing15, EGDSSpacingHr as EGDSSpacingHr2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
// src/components/download-images/download-images-section.tsx
import React29, { useCallback as useCallback9, useEffect as useEffect4, useState as useState12 } from "react";
// src/components/download-images/affiliates-download-images.tsx
import React24 from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5 } from "@egds/react-core/text";
var fragment26 = gql30(_templateObject38(), AffiliatesSpannableText.fragment, AffiliatesButton.fragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesDownloadImages = function(param) {
    var _param_data = param.data, title = _param_data.title, description = _param_data.description, openDownloadImagesGalleryFormButton = _param_data.openDownloadImagesGalleryFormButton, onShowGallery = param.onShowGallery;
    return /* @__PURE__ */ React24.createElement(React24.Fragment, null, /* @__PURE__ */ React24.createElement(EGDSHeading5, {
        tag: "h3",
        size: 6
    }, title), /* @__PURE__ */ React24.createElement(EGDSSpacing12, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React24.createElement("div", null, /* @__PURE__ */ React24.createElement(AffiliatesSpannableText, {
        data: description
    }))), /* @__PURE__ */ React24.createElement(EGDSSpacing12, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React24.createElement(AffiliatesButton, {
        data: openDownloadImagesGalleryFormButton,
        onClickHandler: onShowGallery
    })));
};
AffiliatesDownloadImages.displayName = "AffiliatesDownloadImages";
AffiliatesDownloadImages.fragment = fragment26;
// src/components/download-images/affiliates-download-images-gallery-form.tsx
import React28, { useCallback as useCallback8, useMemo as useMemo15, useState as useState11 } from "react";
import { gql as gql33 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
// src/components/download-images/affiliates-downloadable-image.tsx
import React26, { useState as useState10 } from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSOverlayButton as EGDSOverlayButton2 } from "@egds/react-core/button";
import { EGDSLayoutColumns, EGDSLayoutColumnsItem } from "@egds/react-core/layout-columns";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLoader as EGDSLoader4 } from "@egds/react-core/loader";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
// src/components/download-images/download-images-context.tsx
import React25, { createContext as createContext3, useContext as useContext3, useMemo as useMemo13, useState as useState9 } from "react";
var defaultValue3 = {
    downloadedImages: {},
    setDownloadedImage: void 0
};
var DownloadImagesContext = createContext3(defaultValue3);
var DownloadImagesContextProvider = function(param) {
    var children = param.children;
    var setDownloadedImage = function setDownloadedImage(imageId) {
        setDownloadedImages(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, imageId, true));
        });
    };
    var _useState9 = _sliced_to_array(useState9(defaultValue3.downloadedImages), 2), downloadedImages = _useState9[0], setDownloadedImages = _useState9[1];
    var value = useMemo13(function() {
        return {
            downloadedImages: downloadedImages,
            setDownloadedImage: setDownloadedImage
        };
    }, [
        downloadedImages
    ]);
    return /* @__PURE__ */ React25.createElement(DownloadImagesContext.Provider, {
        value: value
    }, children);
};
var useDownloadImagesContext = function() {
    return useContext3(DownloadImagesContext);
};
// src/components/download-images/affiliates-downloadable-image.tsx
var downloadImageButtonFragment = gql31(_templateObject39());
var fragment27 = gql31(_templateObject40(), AffiliatesButton.fragment, AffiliatesEGDSImage.fragment, AffiliatesAnalytics.interactionFragment, downloadImageButtonFragment);
var DownloadingImageButton = function() {
    return /* @__PURE__ */ React26.createElement(EGDSOverlayButton2, {
        className: "uitk-button-only-icon"
    }, /* @__PURE__ */ React26.createElement(EGDSSpacing13, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(EGDSLoader4, {
        isSmall: true,
        isDarkBackground: true
    }))));
};
var AffiliatesDownloadableImage = function(param) {
    var _param_data = param.data, image = _param_data.image, defaultButton = _param_data.defaultButton, successButton = _param_data.successButton, downloadUrl = _param_data.downloadUrl, imageId = param.imageId;
    var trackEvent = useAnalytics().trackEvent;
    var _useDownloadImagesContext = useDownloadImagesContext(), downloadedImages = _useDownloadImagesContext.downloadedImages, setDownloadedImage = _useDownloadImagesContext.setDownloadedImage;
    var _useState10 = _sliced_to_array(useState10(false), 2), isDownloading = _useState10[0], setIsDownloading = _useState10[1];
    var downloadButton = downloadedImages[imageId] ? successButton : defaultButton;
    var handleDownload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(action) {
            var _ref, response, blob, blobUrl, a;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            3,
                            4
                        ]);
                        setIsDownloading(true);
                        if (action.__typename === "AffiliatesDownloadImageAction") {
                            action.analytics.forEach(trackEvent);
                        }
                        return [
                            4,
                            Promise.all([
                                fetch(downloadUrl, {
                                    method: "GET"
                                }),
                                new Promise(function(resolve) {
                                    setTimeout(function() {
                                        resolve();
                                    }, 500);
                                })
                            ])
                        ];
                    case 1:
                        _ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            1
                        ]), response = _ref[0];
                        return [
                            4,
                            response.blob()
                        ];
                    case 2:
                        blob = _state.sent();
                        blobUrl = window.URL.createObjectURL(blob);
                        a = document.createElement("a");
                        a.download = new URL(downloadUrl).pathname.split("/").pop() || "Image";
                        a.href = blobUrl;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        setDownloadedImage === null || setDownloadedImage === void 0 ? void 0 : setDownloadedImage(imageId);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsDownloading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload(action) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React26.createElement(AffiliatesEGDSImage, {
        data: _object_spread_props(_object_spread({}, image), {
            aspectRatio: "THREE_TWO" /* THREE_TWO */ 
        })
    }, /* @__PURE__ */ React26.createElement(EGDSScrim, {
        type: EGDSScrimType.BOTTOM,
        className: "uitk-card-roundcorner-bottom-left uitk-card-roundcorner-bottom-right"
    }, /* @__PURE__ */ React26.createElement(EGDSLayoutColumns, {
        columns: 1,
        space: "three"
    }, /* @__PURE__ */ React26.createElement(EGDSLayoutColumnsItem, null, /* @__PURE__ */ React26.createElement(EGDSLayoutFlex9, {
        alignItems: "end",
        space: "two",
        direction: "column"
    }, /* @__PURE__ */ React26.createElement(EGDSLayoutFlexItem5, null, isDownloading ? /* @__PURE__ */ React26.createElement(DownloadingImageButton, null) : /* @__PURE__ */ React26.createElement(AffiliatesButton, {
        data: downloadButton,
        onClickHandler: function() {
            return handleDownload(downloadButton.action);
        }
    })))))));
};
AffiliatesDownloadableImage.displayName = "AffiliatesDownloadableImage";
AffiliatesDownloadableImage.fragment = fragment27;
// src/components/download-images/affiliates-pagination.tsx
import React27, { useMemo as useMemo14 } from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSPagingNextButton, EGDSPagingPrevButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
var pagingButtonFragment = gql32(_templateObject41());
var fragment28 = gql32(_templateObject42(), pagingButtonFragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesPagination = function(param) {
    var _param_data = param.data, label = _param_data.label, prevButton = _param_data.prevButton, nextButton = _param_data.nextButton, labelStartPlaceHolder = _param_data.labelStartPlaceHolder, labelEndPlaceHolder = _param_data.labelEndPlaceHolder, pageSize = _param_data.pageSize, totalImages = param.totalImages, currentOffset = param.currentOffset, currentLastImageIndex = param.currentLastImageIndex, handlePrevClick = param.handlePrevClick, handleNextClick = param.handleNextClick;
    var isLastPage = currentOffset + pageSize >= totalImages;
    var isFirstPage = currentLastImageIndex - pageSize < 0;
    var showPhotosLabel = useMemo14(function() {
        var startIndex = (currentOffset + 1).toString();
        var endIndex = (isLastPage ? totalImages : currentLastImageIndex + 1).toString();
        var labelAfterStartInjected = labelStartPlaceHolder ? label === null || label === void 0 ? void 0 : label.replace(labelStartPlaceHolder, startIndex) : label;
        return labelEndPlaceHolder ? labelAfterStartInjected === null || labelAfterStartInjected === void 0 ? void 0 : labelAfterStartInjected.replace(labelEndPlaceHolder, endIndex) : labelAfterStartInjected;
    }, [
        currentOffset,
        currentLastImageIndex,
        isLastPage,
        label,
        labelStartPlaceHolder,
        labelEndPlaceHolder,
        totalImages
    ]);
    return /* @__PURE__ */ React27.createElement(EGDSLayoutFlex10, {
        direction: "row",
        space: "four",
        alignItems: "center",
        justifyContent: "end"
    }, /* @__PURE__ */ React27.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(EGDSPagingPrevButton, {
        iconId: prevButton.iconId,
        iconTitle: prevButton.iconTitle,
        disabled: isFirstPage,
        onClick: handlePrevClick
    }))), /* @__PURE__ */ React27.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React27.createElement(EGDSText9, {
        align: "center"
    }, showPhotosLabel)), /* @__PURE__ */ React27.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */ React27.createElement("div", null, /* @__PURE__ */ React27.createElement(EGDSPagingNextButton, {
        iconId: nextButton.iconId,
        iconTitle: nextButton.iconTitle,
        disabled: isLastPage,
        onClick: handleNextClick
    }))));
};
AffiliatesPagination.displayName = "AffiliatesPagination";
AffiliatesPagination.fragment = fragment28;
// src/components/download-images/affiliates-download-images-gallery-form.tsx
var fragment29 = gql33(_templateObject43(), AffiliatesButton.fragment, AffiliatesDownloadableImage.fragment, AffiliatesPagination.fragment, AffiliatesSpannableText.fragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesDownloadImagesGalleryForm = function(param) {
    var _param_data = param.data, backButton = _param_data.backButton, title = _param_data.title, description = _param_data.description, images = _param_data.images, pagination = _param_data.pagination, onDismiss = param.onDismiss;
    var _useState11 = _sliced_to_array(useState11(0), 2), currentOffset = _useState11[0], setCurrentOffset = _useState11[1];
    var _useState111 = _sliced_to_array(useState11(pagination ? pagination.pageSize - 1 : 0), 2), currentLastImageIndex = _useState111[0], setCurrentLastImageIndex = _useState111[1];
    var trackEvent = useAnalytics().trackEvent;
    var currentImages = useMemo15(function() {
        if (pagination) {
            return images.slice(currentOffset, currentLastImageIndex + 1);
        }
        return images;
    }, [
        images,
        pagination,
        currentOffset,
        currentLastImageIndex
    ]);
    var handleNextClick = useCallback8(function() {
        if (pagination) {
            setCurrentLastImageIndex(currentLastImageIndex + pagination.pageSize);
            setCurrentOffset(currentOffset + pagination.pageSize);
            if (pagination.nextButton.action.__typename === "AffiliatesPagingNextAction") {
                pagination.nextButton.action.analytics.forEach(trackEvent);
            }
        }
    }, [
        pagination,
        currentOffset,
        currentLastImageIndex,
        trackEvent
    ]);
    var handlePrevClick = useCallback8(function() {
        if (pagination) {
            setCurrentOffset(currentOffset - pagination.pageSize);
            setCurrentLastImageIndex(currentLastImageIndex - pagination.pageSize);
            if ((pagination === null || pagination === void 0 ? void 0 : pagination.prevButton.action.__typename) === "AffiliatesPagingPrevAction") {
                pagination === null || pagination === void 0 ? void 0 : pagination.prevButton.action.analytics.forEach(trackEvent);
            }
        }
    }, [
        pagination,
        currentOffset,
        currentLastImageIndex,
        trackEvent
    ]);
    return /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(AffiliatesButton, {
        data: backButton,
        onClickHandler: onDismiss
    }), /* @__PURE__ */ React28.createElement(EGDSSpacing14, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React28.createElement(EGDSHeading6, {
        tag: "h3",
        size: 5
    }, title)), /* @__PURE__ */ React28.createElement(EGDSSpacing14, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(AffiliatesSpannableText, {
        data: description
    }))), /* @__PURE__ */ React28.createElement(EGDSSpacing14, {
        margin: {
            block: "six"
        }
    }, /* @__PURE__ */ React28.createElement(EGDSLayoutGrid, {
        columns: 2,
        space: "two",
        key: currentOffset
    }, /* @__PURE__ */ React28.createElement(React28.Fragment, null, currentImages.map(function(image, index) {
        return /* @__PURE__ */ React28.createElement(EGDSLayoutGridItem, {
            key: index
        }, /* @__PURE__ */ React28.createElement(AffiliatesDownloadableImage, {
            imageId: "".concat(currentOffset, " - ").concat(index),
            data: image
        }));
    })))), pagination && /* @__PURE__ */ React28.createElement(AffiliatesPagination, {
        data: pagination,
        totalImages: images.length,
        currentOffset: currentOffset,
        currentLastImageIndex: currentLastImageIndex,
        handleNextClick: handleNextClick,
        handlePrevClick: handlePrevClick
    }));
};
AffiliatesDownloadImagesGalleryForm.displayName = "AffiliatesDownloadImagesGalleryForm";
AffiliatesDownloadImagesGalleryForm.fragment = fragment29;
// src/components/download-images/download-images-section.tsx
var DownloadImagesSection = function(param) {
    var data = param.data, onToggleGallery = param.onToggleGallery;
    var downloadImages = data.downloadImages, downloadImagesGalleryForm = data.downloadImagesGalleryForm;
    var _useState12 = _sliced_to_array(useState12(false), 2), showGallery = _useState12[0], setShowGallery = _useState12[1];
    var trackEvent = useAnalytics().trackEvent;
    var handleShowGallery = useCallback9(function() {
        setShowGallery(true);
        if (downloadImages.openDownloadImagesGalleryFormButton.action.__typename === "AffiliatesShowDownloadImagesGalleryFormAction") {
            downloadImages.openDownloadImagesGalleryFormButton.action.analytics.forEach(trackEvent);
        }
    }, [
        trackEvent,
        downloadImages
    ]);
    var handleDismissGallery = useCallback9(function() {
        setShowGallery(false);
        if (downloadImagesGalleryForm.backButton.action.__typename === "AffiliatesBackAction") {
            downloadImagesGalleryForm.backButton.action.analytics.forEach(trackEvent);
        }
    }, [
        trackEvent,
        downloadImagesGalleryForm
    ]);
    useEffect4(function() {
        onToggleGallery === null || onToggleGallery === void 0 ? void 0 : onToggleGallery(showGallery);
    }, [
        onToggleGallery,
        showGallery
    ]);
    return /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(DownloadImagesContextProvider, null, showGallery ? /* @__PURE__ */ React29.createElement(AffiliatesDownloadImagesGalleryForm, {
        data: downloadImagesGalleryForm,
        onDismiss: handleDismissGallery
    }) : /* @__PURE__ */ React29.createElement(AffiliatesDownloadImages, {
        data: downloadImages,
        onShowGallery: handleShowGallery
    })));
};
// src/components/affiliate-link/lodging-link-sheet-content.tsx
var fragment30 = gql34(_templateObject44(), AffiliatesAnalytics.interactionFragment, AffiliatesAnalytics.impressionFragment, AffiliatesStandardLink.fragment, AffiliatesEGDSImage.fragment, AffiliatesSwitch.fragment, VanityLinkForm.fragment, AffiliatesIconText.fragment, AffiliatesDownloadImages.fragment, AffiliatesDownloadImagesGalleryForm.fragment, ShareToBlog.fragment, DescriptiveLinkForm.fragment, AffiliatesCopyLinkAction.fragment, AffiliatesViewStatsAction.fragment, CreateVanityTagForm.fragment);
var LodgingLinkSheetContent = function(param) {
    var data = param.data;
    var _data_lodgingInfo_propertyImage, _data_lodgingInfo, _data_lodgingInfo_propertyImage1, _data_lodgingInfo1, _data_lodgingInfo2;
    var _useState13 = _sliced_to_array(useState13(true), 2), showShareToBlog = _useState13[0], setShowShareToBlog = _useState13[1];
    var _useState131 = _sliced_to_array(useState13(true), 2), showImgGallery = _useState131[0], setShowGallery = _useState131[1];
    var _useState132 = _sliced_to_array(useState13(true), 2), showPropertyName = _useState132[0], setShowPropertyName = _useState132[1];
    var downloadImagesSectionData = !!data.downloadImages && !!data.downloadImagesGalleryForm ? {
        downloadImages: data.downloadImages,
        downloadImagesGalleryForm: data.downloadImagesGalleryForm
    } : void 0;
    var hasMoreContentAfterForm = !!downloadImagesSectionData && showImgGallery || showShareToBlog && data.shareToBlog;
    var handleFormChange = function(formType) {
        switch(formType){
            case 1 /* TAG_CREATE */ :
                setShowShareToBlog(false);
                setShowPropertyName(false);
                setShowGallery(false);
                break;
            case 0 /* DESCRIPTIVE */ :
            case 2 /* VANITY_CREATE */ :
            case 3 /* VANITY_SUCCESS */ :
            default:
                setShowShareToBlog(true);
                setShowPropertyName(true);
                setShowGallery(true);
                break;
        }
    };
    return /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
        padding: {
            blockend: "twelve"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(EGDSFigure3, {
        ratio: EGDSFigureAspectRatioType3.R16_9
    }, /* @__PURE__ */ React30.createElement(EGDSImage3, {
        placeholderImage: true,
        alt: (_data_lodgingInfo = data.lodgingInfo) === null || _data_lodgingInfo === void 0 ? void 0 : (_data_lodgingInfo_propertyImage = _data_lodgingInfo.propertyImage) === null || _data_lodgingInfo_propertyImage === void 0 ? void 0 : _data_lodgingInfo_propertyImage.description,
        src: (_data_lodgingInfo1 = data.lodgingInfo) === null || _data_lodgingInfo1 === void 0 ? void 0 : (_data_lodgingInfo_propertyImage1 = _data_lodgingInfo1.propertyImage) === null || _data_lodgingInfo_propertyImage1 === void 0 ? void 0 : _data_lodgingInfo_propertyImage1.url
    })), showPropertyName && ((_data_lodgingInfo2 = data.lodgingInfo) === null || _data_lodgingInfo2 === void 0 ? void 0 : _data_lodgingInfo2.propertyName) && /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
        margin: {
            inline: "six",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React30.createElement(EGDSHeading7, {
        tag: "h2",
        size: 5
    }, data.lodgingInfo.propertyName)), /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
        margin: {
            blockstart: "six",
            inline: "six"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(LinkFormSection, {
        data: data,
        onFormChange: handleFormChange
    }))), hasMoreContentAfterForm && /* @__PURE__ */ React30.createElement(EGDSSpacingHr2, {
        blockMargin: "twelve"
    }), downloadImagesSectionData && showImgGallery && /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
        margin: {
            blockstart: "twelve",
            inline: "six"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(DownloadImagesSection, {
        data: downloadImagesSectionData,
        onToggleGallery: function(showGallery) {
            return setShowShareToBlog(!showGallery);
        }
    }))), showShareToBlog && data.shareToBlog && /* @__PURE__ */ React30.createElement(EGDSSpacing15, {
        margin: {
            blockstart: "twelve",
            inline: "six"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(ShareToBlog, {
        data: data.shareToBlog
    })))));
};
LodgingLinkSheetContent.displayName = "LodgingLinkSheet";
LodgingLinkSheetContent.fragment = fragment30;
// src/components/affiliate-link/link-sheet.tsx
function LinkSheetContent(param) {
    var data = param.data;
    switch(data.__typename){
        case "AffiliatesCreateLinkDefaultSuccessResponse":
            return /* @__PURE__ */ React31.createElement(DefaultLinkSheetContent, {
                data: data
            });
        case "AffiliatesCreateLinkLodgingSuccessResponse":
            return /* @__PURE__ */ React31.createElement(LodgingLinkSheetContent, {
                data: data
            });
        case "AffiliatesCreateLinkFailureResponse":
            return /* @__PURE__ */ React31.createElement(LinkSheetFailureContent, {
                data: data
            });
        case "UIBanner":
        default:
            return /* @__PURE__ */ React31.createElement(SheetErrorContent, {
                data: data
            });
    }
}
function ViewStatsLink(param) {
    var data = param.data, onClick = param.onClick;
    switch(data === null || data === void 0 ? void 0 : data.__typename){
        case "AffiliatesCreateLinkDefaultSuccessResponse":
        case "AffiliatesCreateLinkLodgingSuccessResponse":
            return (data === null || data === void 0 ? void 0 : data.statsLink) ? /* @__PURE__ */ React31.createElement(EGDSToolbarButton, {
                onClick: onClick
            }, data === null || data === void 0 ? void 0 : data.statsLink.text) : null;
        case "AffiliatesCreateLinkFailureResponse":
            return (data === null || data === void 0 ? void 0 : data.statsLink) ? /* @__PURE__ */ React31.createElement(EGDSToolbarButton, {
                onClick: onClick
            }, data === null || data === void 0 ? void 0 : data.statsLink.text) : null;
        case "UIBanner":
        default:
            return null;
    }
}
var LinkSheet = function(param) {
    var onSheetToolbarClick = param.onSheetToolbarClick, loading = param.loading, data = param.data;
    var _useStripeContext = useStripeContext(), linkSheetTriggerRef = _useStripeContext.linkSheetTriggerRef, activeSheet = _useStripeContext.activeSheet, setActiveSheet = _useStripeContext.setActiveSheet;
    var trackEvent = useAnalytics().trackEvent;
    var handleCloseButtonClick = useCallback10(function() {
        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("NONE" /* NONE */ );
        if ((data === null || data === void 0 ? void 0 : data.__typename) !== "UIBanner") {
            data === null || data === void 0 ? void 0 : data.closeAction.analytics.forEach(trackEvent);
        }
    }, [
        setActiveSheet,
        trackEvent,
        data
    ]);
    useEffect5(function() {
        if ((data === null || data === void 0 ? void 0 : data.__typename) !== "UIBanner") {
            var _data_impressionAnalytics;
            data === null || data === void 0 ? void 0 : (_data_impressionAnalytics = data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics.forEach(trackEvent);
        }
    }, [
        trackEvent,
        data
    ]);
    return /* @__PURE__ */ React31.createElement(EGDSSheetTransition, {
        isVisible: activeSheet === "LINK" /* LINK */ 
    }, /* @__PURE__ */ React31.createElement(EGDSSheet, {
        type: "side",
        triggerRef: linkSheetTriggerRef,
        isVisible: activeSheet === "LINK" /* LINK */ 
    }, /* @__PURE__ */ React31.createElement(EGDSToolbar, {
        navigationContent: {
            navIconLabel: "Close",
            onClick: handleCloseButtonClick
        },
        toolbarActionContent: /* @__PURE__ */ React31.createElement(ViewStatsLink, {
            data: data,
            onClick: onSheetToolbarClick
        })
    }), /* @__PURE__ */ React31.createElement(EGDSSheetContent, {
        padded: false
    }, loading && /* @__PURE__ */ React31.createElement(SheetLoader, null), !loading && data && /* @__PURE__ */ React31.createElement(LinkSheetContent, {
        data: data
    }))));
};
// src/components/affiliate-link/create-link-mutation.ts
import { gql as gql35 } from "@apollo/client";
var createLinkMutation = gql35(_templateObject45(), LodgingLinkSheetContent.fragment, DefaultLinkSheetContent.fragment, LinkSheetFailureContent.fragment);
// src/hooks/use-open-link-sheet.ts
function useOpenLinkSheet() {
    var context = useBexApi3().context;
    var _useStripeContext = useStripeContext(), clientContext = _useStripeContext.clientContext, propertyContext = _useStripeContext.propertyContext, targetUrl = _useStripeContext.targetUrl, setActiveMenu = _useStripeContext.setActiveMenu, setActiveSheet = _useStripeContext.setActiveSheet, setLinkSheetContent = _useStripeContext.setLinkSheetContent;
    var trackEvent = useAnalytics().trackEvent;
    var _useMutation3 = _sliced_to_array(useMutation3(createLinkMutation), 1), createLink = _useMutation3[0];
    var openLinkSheet = useCallback11(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(action) {
            var _action_analytics, response, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLinkSheetContent === null || setLinkSheetContent === void 0 ? void 0 : setLinkSheetContent({
                            type: 2 /* LOADING */ 
                        });
                        setActiveMenu === null || setActiveMenu === void 0 ? void 0 : setActiveMenu("NONE" /* NONE */ );
                        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("LINK" /* LINK */ );
                        action === null || action === void 0 ? void 0 : (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.forEach(trackEvent);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            createLink({
                                variables: {
                                    context: context,
                                    clientContext: clientContext,
                                    request: {
                                        targetUrl: targetUrl,
                                        propertyContext: propertyContext
                                    }
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        setLinkSheetContent === null || setLinkSheetContent === void 0 ? void 0 : setLinkSheetContent({
                            type: 3 /* DATA */ ,
                            data: response.data.createAffiliateLink
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (action === null || action === void 0 ? void 0 : action.unexpectedErrorMessage) {
                            setLinkSheetContent === null || setLinkSheetContent === void 0 ? void 0 : setLinkSheetContent({
                                type: 3 /* DATA */ ,
                                data: action.unexpectedErrorMessage
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(action) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setLinkSheetContent,
        setActiveMenu,
        setActiveSheet,
        createLink,
        trackEvent,
        context,
        clientContext,
        targetUrl,
        propertyContext
    ]);
    return {
        openLinkSheet: openLinkSheet
    };
}
// src/hooks/use-open-stats-sheet.ts
import { useCallback as useCallback15 } from "react";
import { useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
// src/components/stats/get-stats-query.ts
import { gql as gql44 } from "@apollo/client";
// src/components/stats/stats-sheet-content.tsx
import React38 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing18, EGDSSpacingHr as EGDSSpacingHr4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading14 } from "@egds/react-core/text";
// src/components/stats/alternate-properties.tsx
import React32, { useCallback as useCallback12, useState as useState14 } from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText10 } from "@egds/react-core/text";
var itemFragment = gql36(_templateObject46(), AffiliatesIconText.fragment, AffiliatesOutwardLinkAction.fragment);
var fragment31 = gql36(_templateObject47(), itemFragment, AffiliatesEGDSImage.fragment, AffiliatesAnalytics.interactionFragment);
var AlternateProperties = function(param) {
    var data = param.data;
    var _data_nextButton, _data_previousButton, _data_nextButton1, _data_previousButton1;
    var _useState14 = _sliced_to_array(useState14(0), 2), currentIndex = _useState14[0], setCurrentIndex = _useState14[1];
    var trackEvent = useAnalytics().trackEvent;
    var trackCarouselEvent = useTrackCarouselEvent().trackCarouselEvent;
    var handleIndexChange = useCallback12(function(nextIndex) {
        if (data.nextButton.action.__typename === "AffiliatesPagingNextAction" && data.previousButton.action.__typename === "AffiliatesPagingPrevAction") {
            trackCarouselEvent(nextIndex, currentIndex, data.nextButton.action.analytics, data.previousButton.action.analytics);
        }
        setCurrentIndex(nextIndex);
    }, [
        currentIndex,
        data,
        trackCarouselEvent
    ]);
    var props = {
        itemsMaxHeight: true,
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 2
        },
        pageBy: 1,
        peek: true,
        peekAmount: {
            sm: 128,
            md: 128,
            lg: 128
        },
        wrapItems: true,
        navigationIconId: {
            next: (_data_nextButton = data.nextButton) === null || _data_nextButton === void 0 ? void 0 : _data_nextButton.iconId,
            prev: (_data_previousButton = data.previousButton) === null || _data_previousButton === void 0 ? void 0 : _data_previousButton.iconId
        },
        buttonText: {
            nextButton: (_data_nextButton1 = data.nextButton) === null || _data_nextButton1 === void 0 ? void 0 : _data_nextButton1.iconTitle,
            prevButton: (_data_previousButton1 = data.previousButton) === null || _data_previousButton1 === void 0 ? void 0 : _data_previousButton1.iconTitle
        },
        // Using this callback to trigger analytics events
        onIndexChange: handleIndexChange
    };
    var alternateProperties = data.items.map(function(property, propertyIndex) {
        var cardLinkUrl = property.cardLinkAction.url;
        var handleCardClick = function() {
            if (property.cardLinkAction.__typename === "AffiliatesOutwardLinkAction") {
                property.cardLinkAction.analytics.forEach(trackEvent);
            }
        };
        var propertyImage = _object_spread_props(_object_spread({
            __typename: "Image",
            url: "",
            description: "Alternate property image"
        }, property.image || {}), {
            aspectRatio: "THREE_TWO" /* THREE_TWO */ 
        });
        return /* @__PURE__ */ React32.createElement(EGDSCard2, {
            border: true,
            key: "Alternate Property - ".concat(propertyIndex)
        }, /* @__PURE__ */ React32.createElement(AffiliatesEGDSImage, {
            data: propertyImage
        }), /* @__PURE__ */ React32.createElement(EGDSCardLink, null, /* @__PURE__ */ React32.createElement("a", {
            target: "_blank",
            href: cardLinkUrl,
            rel: "noopener",
            onClick: handleCardClick
        }, property.title)), /* @__PURE__ */ React32.createElement(EGDSCardContentSection2, null, /* @__PURE__ */ React32.createElement(EGDSLayoutFlex11, {
            direction: "column",
            space: "three"
        }, /* @__PURE__ */ React32.createElement(EGDSLayoutFlex11, {
            direction: "column",
            space: "one"
        }, /* @__PURE__ */ React32.createElement(EGDSHeading8, {
            tag: "h4",
            size: 6
        }, property.title), /* @__PURE__ */ React32.createElement(EGDSText10, {
            size: 300
        }, property.subTitle)), /* @__PURE__ */ React32.createElement(EGDSLayoutFlex11, {
            direction: "column",
            space: "two"
        }, (property.amenities || []).map(function(amenity, i) {
            return /* @__PURE__ */ React32.createElement(EGDSLayoutFlexItem7, {
                key: "Amenity - ".concat(i)
            }, /* @__PURE__ */ React32.createElement(AffiliatesIconText, {
                data: amenity
            }));
        })), /* @__PURE__ */ React32.createElement(EGDSText10, {
            size: 300
        }, /* @__PURE__ */ React32.createElement(EGDSText10, {
            inline: "strong"
        }, property.overAllRating), "\xA0", property.overAllDescription, " ", property.reviewsStat))));
    });
    return /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(EGDSHeading8, {
        tag: "h3",
        size: 5
    }, data.title), /* @__PURE__ */ React32.createElement(EGDSCarousel, _object_spread({}, props), alternateProperties));
};
AlternateProperties.displayName = "AlternateProperties";
AlternateProperties.fragment = fragment31;
// src/components/stats/avg-stay.tsx
import React33 from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading9, EGDSText as EGDSText11 } from "@egds/react-core/text";
var fragment32 = gql37(_templateObject48());
var AvgStay = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React33.createElement(EGDSCard3, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React33.createElement(EGDSLayoutFlex12, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React33.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React33.createElement(EGDSHeading9, {
        tag: "h3",
        size: 6
    }, data === null || data === void 0 ? void 0 : data.title)), /* @__PURE__ */ React33.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */ React33.createElement(EGDSText11, {
        size: 200
    }, data === null || data === void 0 ? void 0 : data.subtitle))));
};
AvgStay.displayName = "AvgStay";
AvgStay.fragment = fragment32;
// src/components/stats/commission-info.tsx
import React34 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex13 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10, EGDSText as EGDSText12 } from "@egds/react-core/text";
var fragment33 = gql38(_templateObject49(), AffiliatesEGDSMark.fragment);
var CommissionInfo = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React34.createElement(EGDSCard4, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React34.createElement(EGDSHeading10, {
        tag: "h3"
    }, data === null || data === void 0 ? void 0 : data.title), /* @__PURE__ */ React34.createElement(EGDSSpacing16, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, {
        alignItems: "center",
        space: "two"
    }, (data === null || data === void 0 ? void 0 : data.brandLogo) && /* @__PURE__ */ React34.createElement(AffiliatesEGDSMark, {
        data: _object_spread_props(_object_spread({}, data.brandLogo), {
            size: "4"
        })
    }), /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 100
    }, data === null || data === void 0 ? void 0 : data.brandDomain))), /* @__PURE__ */ React34.createElement(EGDSSpacing16, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React34.createElement(EGDSLayoutGrid2, {
        space: "three",
        columns: [
            "1fr",
            "1fr"
        ]
    }, (data === null || data === void 0 ? void 0 : data.estimatedCommission) && /* @__PURE__ */ React34.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React34.createElement(EGDSText12, {
        theme: "positive",
        size: 300
    }, data.estimatedCommission.title), /* @__PURE__ */ React34.createElement(EGDSText12, {
        inline: "strong",
        theme: "positive",
        size: 500
    }, data.estimatedCommission.value))), (data === null || data === void 0 ? void 0 : data.avgBookingValue) && /* @__PURE__ */ React34.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 300
    }, data.avgBookingValue.title), /* @__PURE__ */ React34.createElement(EGDSText12, {
        inline: "strong",
        size: 500
    }, data.avgBookingValue.value))), /* @__PURE__ */ React34.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 200
    }, data === null || data === void 0 ? void 0 : data.commissionRate.title), /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 400,
        theme: "emphasis"
    }, data === null || data === void 0 ? void 0 : data.commissionRate.value)))), /* @__PURE__ */ React34.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, null, /* @__PURE__ */ React34.createElement(EGDSLayoutFlex13, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 200
    }, data === null || data === void 0 ? void 0 : data.validityPeriod.title), /* @__PURE__ */ React34.createElement(EGDSText12, {
        size: 400,
        theme: "emphasis"
    }, data === null || data === void 0 ? void 0 : data.validityPeriod.value)))))));
};
CommissionInfo.displayName = "CommissionInfo";
CommissionInfo.fragment = fragment33;
// src/components/stats/highlighted-reviews.tsx
import React35, { useCallback as useCallback13, useRef, useState as useState15 } from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex14 } from "@egds/react-core/layout-flex";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSheet as EGDSSheet2, EGDSSheetCloseButton, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing17, EGDSSpacingHr as EGDSSpacingHr3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11, EGDSParagraph, EGDSText as EGDSText13 } from "@egds/react-core/text";
var highlightedReviewFragment = gql39(_templateObject50());
var fragment34 = gql39(_templateObject51(), AffiliatesAnalytics.interactionFragment, AffiliatesSpannableText.fragment, AffiliatesEGDSIcon.fragment, highlightedReviewFragment);
var HighlightedReviews = function(param) {
    var data = param.data;
    var _data_positiveReview, _data_criticalReview, _data_infoButton_button_icon;
    var trackEvent = useAnalytics().trackEvent;
    var infoButton = data.infoButton, infoDialog = data.infoDialog;
    var _React35_useState = _sliced_to_array(React35.useState(data === null || data === void 0 ? void 0 : (_data_positiveReview = data.positiveReview) === null || _data_positiveReview === void 0 ? void 0 : _data_positiveReview.textControl.expanded), 2), favorableReviewIsVisible = _React35_useState[0], setFavorableReviewIsVisible = _React35_useState[1];
    var _React35_useState1 = _sliced_to_array(React35.useState(data === null || data === void 0 ? void 0 : (_data_criticalReview = data.criticalReview) === null || _data_criticalReview === void 0 ? void 0 : _data_criticalReview.textControl.expanded), 2), criticalReviewIsVisible = _React35_useState1[0], setCriticalReviewIsVisible = _React35_useState1[1];
    var triggerRef = useRef(null);
    var _useState15 = _sliced_to_array(useState15(false), 2), visible = _useState15[0], setVisible = _useState15[1];
    var toggleVisibility = useCallback13(function() {
        var _infoButton_action, _infoDialog_closeButton_action, _infoDialog_closeButton;
        var nextVisible = !visible;
        setVisible(!visible);
        var analyticsEvents;
        if (nextVisible && (infoButton === null || infoButton === void 0 ? void 0 : (_infoButton_action = infoButton.action) === null || _infoButton_action === void 0 ? void 0 : _infoButton_action.__typename) === "AffiliatesShowHighlightedReviewsInfoAction") {
            analyticsEvents = infoButton.action.analytics;
        } else if (!nextVisible && (infoDialog === null || infoDialog === void 0 ? void 0 : (_infoDialog_closeButton = infoDialog.closeButton) === null || _infoDialog_closeButton === void 0 ? void 0 : (_infoDialog_closeButton_action = _infoDialog_closeButton.action) === null || _infoDialog_closeButton_action === void 0 ? void 0 : _infoDialog_closeButton_action.__typename) === "AffiliatesCloseAction") {
            analyticsEvents = infoDialog.closeButton.action.analytics;
        }
        analyticsEvents === null || analyticsEvents === void 0 ? void 0 : analyticsEvents.forEach(trackEvent);
    }, [
        setVisible,
        trackEvent,
        visible,
        infoButton.action,
        infoDialog.closeButton
    ]);
    return /* @__PURE__ */ React35.createElement(EGDSCard5, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        direction: "column",
        space: "four"
    }, /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        alignItems: "start",
        space: "one"
    }, /* @__PURE__ */ React35.createElement(EGDSHeading11, {
        tag: "h3",
        size: 7
    }, data === null || data === void 0 ? void 0 : data.title), (data === null || data === void 0 ? void 0 : (_data_infoButton_button_icon = data.infoButton.button.icon) === null || _data_infoButton_button_icon === void 0 ? void 0 : _data_infoButton_button_icon.token) && /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(EGDSMoreInfoTrigger, null, /* @__PURE__ */ React35.createElement("button", {
        type: "button",
        onClick: toggleVisibility,
        ref: triggerRef
    }, /* @__PURE__ */ React35.createElement(EGDSIcon3, {
        name: data.infoButton.button.icon.token,
        id: data.infoButton.button.icon.id,
        description: data.infoButton.button.icon.description,
        title: data.infoButton.button.icon.description
    }))), /* @__PURE__ */ React35.createElement(EGDSSheetTransition2, {
        isVisible: visible
    }, /* @__PURE__ */ React35.createElement(EGDSSheet2, {
        position: {
            inline: "leading",
            block: "trailing"
        },
        isVisible: visible,
        type: "popover",
        triggerRef: triggerRef,
        onDismiss: toggleVisibility
    }, /* @__PURE__ */ React35.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */ React35.createElement(EGDSTertiaryButton2, {
        type: "button",
        onClick: toggleVisibility
    }, /* @__PURE__ */ React35.createElement(EGDSIcon3, {
        name: "close"
    }))), /* @__PURE__ */ React35.createElement(EGDSSpacing17, {
        padding: {
            inlinestart: "six",
            inlineend: "unset"
        }
    }, /* @__PURE__ */ React35.createElement(EGDSSheetContent2, null, /* @__PURE__ */ React35.createElement(EGDSParagraph, null, " ", data.infoDialog.message.inlineContent[0].text))))))), /* @__PURE__ */ React35.createElement(EGDSCardContentSection3, {
        padded: false
    }, (data === null || data === void 0 ? void 0 : data.positiveReview) && /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 200,
        theme: "positive"
    }, data.positiveReview.title), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, data.positiveReview.rating), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 300,
        weight: "medium",
        theme: "standard"
    }, data.positiveReview.reviewerName), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 200,
        weight: "regular",
        theme: "standard"
    }, data.positiveReview.date)), /* @__PURE__ */ React35.createElement(EGDSExpandoPeek, {
        isVisible: favorableReviewIsVisible,
        handleClick: function() {
            return setFavorableReviewIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: data.positiveReview.textControl.lines || 0,
        expandLabel: data.positiveReview.textControl.collapsedLabel,
        collapseLabel: data.positiveReview.textControl.expandedLabel,
        expandA11yLabel: data.positiveReview.textControl.collapsedAccessibilityText || "",
        collapseA11yLabel: data.positiveReview.textControl.expandedAccessibilityText || "",
        hideScrim: true
    }, /* @__PURE__ */ React35.createElement(EGDSParagraph, null, data.positiveReview.text))), (data === null || data === void 0 ? void 0 : data.criticalReview) && (data === null || data === void 0 ? void 0 : data.positiveReview) && /* @__PURE__ */ React35.createElement(EGDSSpacingHr3, null), (data === null || data === void 0 ? void 0 : data.criticalReview) && /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React35.createElement(EGDSLayoutFlex14, {
        direction: "column",
        space: "one"
    }, /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 200,
        theme: "negative"
    }, data.criticalReview.title), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 400,
        weight: "medium",
        theme: "emphasis"
    }, data.criticalReview.rating), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 300,
        weight: "medium",
        theme: "standard"
    }, data.criticalReview.reviewerName), /* @__PURE__ */ React35.createElement(EGDSText13, {
        size: 200,
        weight: "regular",
        theme: "standard"
    }, data.criticalReview.date)), /* @__PURE__ */ React35.createElement(EGDSExpandoPeek, {
        isVisible: criticalReviewIsVisible,
        handleClick: function() {
            return setCriticalReviewIsVisible(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        lines: data.criticalReview.textControl.lines || 0,
        expandLabel: data.criticalReview.textControl.collapsedLabel,
        collapseLabel: data.criticalReview.textControl.expandedLabel,
        expandA11yLabel: data.criticalReview.textControl.collapsedAccessibilityText || "",
        collapseA11yLabel: data.criticalReview.textControl.expandedAccessibilityText || "",
        hideScrim: true
    }, /* @__PURE__ */ React35.createElement(EGDSParagraph, null, data.criticalReview.text))))));
};
HighlightedReviews.displayName = "HighlightedReviews";
HighlightedReviews.fragment = fragment34;
// src/components/stats/popular-places-to-visit.tsx
import React36, { useCallback as useCallback14, useState as useState16 } from "react";
import { gql as gql40 } from "@apollo/client";
import { EGDSCard as EGDSCard6, EGDSCardContentSection as EGDSCardContentSection4, EGDSCardLink as EGDSCardLink2 } from "@egds/react-core/cards";
import { EGDSCarousel as EGDSCarousel2 } from "@egds/react-core/carousel";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading12, EGDSText as EGDSText14 } from "@egds/react-core/text";
var itemFragment2 = gql40(_templateObject52(), AffiliatesOutwardLinkAction.fragment, AffiliatesEGDSImage.fragment);
var fragment35 = gql40(_templateObject53(), AffiliatesAnalytics.interactionFragment, itemFragment2);
var PopularPlacesToVisit = function(param) {
    var data = param.data;
    var _data_nextButton, _data_previousButton, _data_nextButton1, _data_previousButton1;
    var trackEvent = useAnalytics().trackEvent;
    var trackCarouselEvent = useTrackCarouselEvent().trackCarouselEvent;
    var _useState16 = _sliced_to_array(useState16(0), 2), currentIndex = _useState16[0], setCurrentIndex = _useState16[1];
    var handleIndexChange = useCallback14(function(nextIndex) {
        if (data.nextButton.action.__typename === "AffiliatesPagingNextAction" && data.previousButton.action.__typename === "AffiliatesPagingPrevAction") {
            trackCarouselEvent(nextIndex, currentIndex, data.nextButton.action.analytics, data.previousButton.action.analytics);
        }
        setCurrentIndex(nextIndex);
    }, [
        currentIndex,
        data,
        trackCarouselEvent
    ]);
    var props = {
        carouselName: "Popular places to visit ",
        carouselHeaderText: "Popular places to visit carousel",
        itemsMaxHeight: true,
        itemsVisible: {
            sm: 1,
            md: 2,
            lg: 2
        },
        pageBy: 1,
        peek: true,
        peekAmount: {
            sm: 150,
            md: 150,
            lg: 150
        },
        wrapItems: true,
        navigationIconId: {
            next: (_data_nextButton = data.nextButton) === null || _data_nextButton === void 0 ? void 0 : _data_nextButton.iconId,
            prev: (_data_previousButton = data.previousButton) === null || _data_previousButton === void 0 ? void 0 : _data_previousButton.iconId
        },
        buttonText: {
            nextButton: (_data_nextButton1 = data.nextButton) === null || _data_nextButton1 === void 0 ? void 0 : _data_nextButton1.iconTitle,
            prevButton: (_data_previousButton1 = data.previousButton) === null || _data_previousButton1 === void 0 ? void 0 : _data_previousButton1.iconTitle
        },
        onIndexChange: handleIndexChange
    };
    var popularPlaces = data.items.map(function(place, i) {
        var cardLinkUrl = place.cardLinkAction.url;
        var handleCardClick = function() {
            if (place.cardLinkAction.__typename === "AffiliatesOutwardLinkAction") {
                place.cardLinkAction.analytics.forEach(trackEvent);
            }
        };
        var placeImage = _object_spread_props(_object_spread({
            __typename: "Image",
            url: "",
            description: "Popular place to visit image"
        }, place.card.image || {}), {
            aspectRatio: "THREE_TWO" /* THREE_TWO */ 
        });
        return /* @__PURE__ */ React36.createElement(EGDSCard6, {
            border: true,
            key: "Popular place - ".concat(i)
        }, !!cardLinkUrl && /* @__PURE__ */ React36.createElement(EGDSCardLink2, null, /* @__PURE__ */ React36.createElement("a", {
            href: cardLinkUrl,
            target: "_blank",
            onClick: handleCardClick,
            rel: "noopener"
        }, "Link to ", place.card.title)), /* @__PURE__ */ React36.createElement(AffiliatesEGDSImage, {
            data: placeImage
        }), /* @__PURE__ */ React36.createElement(EGDSCardContentSection4, null, /* @__PURE__ */ React36.createElement(EGDSLayoutFlex15, {
            direction: "column",
            space: "four"
        }, /* @__PURE__ */ React36.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(EGDSHeading12, {
            tag: "h4",
            size: 7
        }, place.card.title), /* @__PURE__ */ React36.createElement(EGDSText14, {
            size: 200
        }, place.card.subTitle))), /* @__PURE__ */ React36.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */ React36.createElement(EGDSText14, {
            size: 200
        }, place.card.description)))));
    });
    return /* @__PURE__ */ React36.createElement(EGDSLayoutFlex15, {
        direction: "column",
        space: "six"
    }, /* @__PURE__ */ React36.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */ React36.createElement(EGDSHeading12, {
        tag: "h3",
        size: 5
    }, data.title)), /* @__PURE__ */ React36.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */ React36.createElement(EGDSCarousel2, _object_spread({}, props), popularPlaces)));
};
PopularPlacesToVisit.displayName = "PopularPlacesToVisit";
PopularPlacesToVisit.fragment = fragment35;
// src/components/stats/ratings.tsx
import React37 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSCard as EGDSCard7 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex16 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSProgressBar } from "@egds/react-core/progress-bar";
import { EGDSHeading as EGDSHeading13, EGDSText as EGDSText15 } from "@egds/react-core/text";
var fragment36 = gql41(_templateObject54());
var Ratings = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React37.createElement(EGDSCard7, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React37.createElement(EGDSLayoutFlex16, {
        direction: "column",
        space: "four",
        "data-cy": "stats-ratings"
    }, /* @__PURE__ */ React37.createElement(EGDSHeading13, {
        tag: "h3",
        size: 6
    }, data.title), /* @__PURE__ */ React37.createElement(EGDSLayoutFlex16, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React37.createElement(EGDSText15, {
        size: 700,
        weight: "medium"
    }, data.overAllRating), /* @__PURE__ */ React37.createElement(EGDSText15, {
        size: 500,
        weight: "medium"
    }, data.overAllDescription)), /* @__PURE__ */ React37.createElement(EGDSLayoutFlex16, {
        direction: "column",
        space: "two"
    }, data.grades.map(function(grade) {
        return grade.title && grade.progressDescription ? /* @__PURE__ */ React37.createElement(EGDSProgressBar, {
            key: grade.title,
            percent: grade.percent,
            title: grade.title,
            progressDescription: grade.progressDescription
        }) : null;
    })), /* @__PURE__ */ React37.createElement(EGDSLayoutGrid3, {
        space: "four",
        columns: [
            "1fr",
            "1fr"
        ]
    }, data.categories.map(function(category) {
        return /* @__PURE__ */ React37.createElement(EGDSLayoutGridItem3, {
            key: category.description
        }, /* @__PURE__ */ React37.createElement(EGDSLayoutFlex16, {
            direction: "column",
            space: "one"
        }, /* @__PURE__ */ React37.createElement(EGDSText15, {
            size: 500,
            weight: "medium"
        }, category.title), /* @__PURE__ */ React37.createElement(EGDSText15, {
            size: 200
        }, category.description)));
    }))));
};
Ratings.displayName = "Ratings";
Ratings.fragment = fragment36;
// src/components/stats/stats-sheet-content.tsx
var fragment37 = gql42(_templateObject55(), AffiliatesEGDSImage.fragment, CommissionInfo.fragment, AvgStay.fragment, Ratings.fragment, HighlightedReviews.fragment, AlternateProperties.fragment, PopularPlacesToVisit.fragment, AffiliatesStandardLink.fragment, AffiliatesAnalytics.impressionFragment, AffiliatesAnalytics.interactionFragment, AffiliatesCreateLinkAction.fragment);
var StatsSheetContent = function(param) {
    var data = param.data;
    var _data_analyticsInfo_guestReviews, _data_analyticsInfo, _data_analyticsInfo1, _data_analyticsInfo_guestReviews1, _data_analyticsInfo2, _data_lodgingInfo_propertyImage, _data_lodgingInfo_propertyImage1, _data_lodgingInfo, _data_analyticsInfo3, _data_analyticsInfo4, _data_analyticsInfo5, _data_analyticsInfo6, _data_analyticsInfo_guestReviews2, _data_analyticsInfo7, _data_analyticsInfo_guestReviews3, _data_analyticsInfo8, _data_analyticsInfo9, _data_analyticsInfo10, _data_analyticsInfo11, _data_analyticsInfo12;
    var analyticsDataExists = !!((_data_analyticsInfo = data.analyticsInfo) === null || _data_analyticsInfo === void 0 ? void 0 : (_data_analyticsInfo_guestReviews = _data_analyticsInfo.guestReviews) === null || _data_analyticsInfo_guestReviews === void 0 ? void 0 : _data_analyticsInfo_guestReviews.highlightedReviews) || !!((_data_analyticsInfo1 = data.analyticsInfo) === null || _data_analyticsInfo1 === void 0 ? void 0 : _data_analyticsInfo1.avgStay) || !!((_data_analyticsInfo2 = data.analyticsInfo) === null || _data_analyticsInfo2 === void 0 ? void 0 : (_data_analyticsInfo_guestReviews1 = _data_analyticsInfo2.guestReviews) === null || _data_analyticsInfo_guestReviews1 === void 0 ? void 0 : _data_analyticsInfo_guestReviews1.ratings);
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, /* @__PURE__ */ React38.createElement(EGDSFigure4, {
        ratio: EGDSFigureAspectRatioType4.R16_9
    }, /* @__PURE__ */ React38.createElement(EGDSImage4, {
        placeholderImage: true,
        alt: (_data_lodgingInfo_propertyImage = data.lodgingInfo.propertyImage) === null || _data_lodgingInfo_propertyImage === void 0 ? void 0 : _data_lodgingInfo_propertyImage.description,
        src: (_data_lodgingInfo_propertyImage1 = data.lodgingInfo.propertyImage) === null || _data_lodgingInfo_propertyImage1 === void 0 ? void 0 : _data_lodgingInfo_propertyImage1.url
    })), /* @__PURE__ */ React38.createElement(EGDSSpacing18, {
        margin: "six"
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSLayoutFlex17, {
        direction: "column",
        space: "four"
    }, !!((_data_lodgingInfo = data.lodgingInfo) === null || _data_lodgingInfo === void 0 ? void 0 : _data_lodgingInfo.propertyName) && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(EGDSHeading14, {
        tag: "h2",
        size: 4
    }, data.lodgingInfo.propertyName)), !!data.commissionInfo && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(CommissionInfo, {
        data: data.commissionInfo
    }))))), (!!((_data_analyticsInfo3 = data.analyticsInfo) === null || _data_analyticsInfo3 === void 0 ? void 0 : _data_analyticsInfo3.popularPlacesToVisit) || !!((_data_analyticsInfo4 = data.analyticsInfo) === null || _data_analyticsInfo4 === void 0 ? void 0 : _data_analyticsInfo4.alternateProperties) || analyticsDataExists) && /* @__PURE__ */ React38.createElement(EGDSSpacingHr4, {
        blockMargin: data.commissionInfo ? "twelve" : "four"
    }), /* @__PURE__ */ React38.createElement(EGDSSpacing18, {
        margin: "six"
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSLayoutFlex17, {
        direction: "column",
        space: "six"
    }, !!((_data_analyticsInfo5 = data.analyticsInfo) === null || _data_analyticsInfo5 === void 0 ? void 0 : _data_analyticsInfo5.title) && analyticsDataExists && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(EGDSHeading14, {
        tag: "h2",
        size: 4
    }, data.analyticsInfo.title)), !!((_data_analyticsInfo6 = data.analyticsInfo) === null || _data_analyticsInfo6 === void 0 ? void 0 : _data_analyticsInfo6.avgStay) && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(AvgStay, {
        data: data.analyticsInfo.avgStay
    })), !!((_data_analyticsInfo7 = data.analyticsInfo) === null || _data_analyticsInfo7 === void 0 ? void 0 : (_data_analyticsInfo_guestReviews2 = _data_analyticsInfo7.guestReviews) === null || _data_analyticsInfo_guestReviews2 === void 0 ? void 0 : _data_analyticsInfo_guestReviews2.ratings) && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(Ratings, {
        data: data.analyticsInfo.guestReviews.ratings
    })), !!((_data_analyticsInfo8 = data.analyticsInfo) === null || _data_analyticsInfo8 === void 0 ? void 0 : (_data_analyticsInfo_guestReviews3 = _data_analyticsInfo8.guestReviews) === null || _data_analyticsInfo_guestReviews3 === void 0 ? void 0 : _data_analyticsInfo_guestReviews3.highlightedReviews) && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(HighlightedReviews, {
        data: data.analyticsInfo.guestReviews.highlightedReviews
    })), !!((_data_analyticsInfo9 = data.analyticsInfo) === null || _data_analyticsInfo9 === void 0 ? void 0 : _data_analyticsInfo9.alternateProperties) && /* @__PURE__ */ React38.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */ React38.createElement(AlternateProperties, {
        data: data.analyticsInfo.alternateProperties
    }))))), !!((_data_analyticsInfo10 = data.analyticsInfo) === null || _data_analyticsInfo10 === void 0 ? void 0 : _data_analyticsInfo10.popularPlacesToVisit) && (analyticsDataExists || !!((_data_analyticsInfo11 = data.analyticsInfo) === null || _data_analyticsInfo11 === void 0 ? void 0 : _data_analyticsInfo11.alternateProperties)) && /* @__PURE__ */ React38.createElement(EGDSSpacingHr4, {
        blockMargin: "twelve"
    }), !!((_data_analyticsInfo12 = data.analyticsInfo) === null || _data_analyticsInfo12 === void 0 ? void 0 : _data_analyticsInfo12.popularPlacesToVisit) && /* @__PURE__ */ React38.createElement(EGDSSpacing18, {
        margin: "six"
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(PopularPlacesToVisit, {
        data: data.analyticsInfo.popularPlacesToVisit
    }))));
};
StatsSheetContent.displayName = "StatsSheetContent";
StatsSheetContent.fragment = fragment37;
// src/components/stats/stats-sheet-failure-content.tsx
import React39 from "react";
import { gql as gql43 } from "@apollo/client";
var fragment38 = gql43(_templateObject56(), AffiliatesEGDSBanner.fragment, AffiliatesAnalytics.impressionFragment, AffiliatesAnalytics.interactionFragment, AffiliatesStandardLink.fragment, AffiliatesCreateLinkAction.fragment);
var StatsSheetFailureContent = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React39.createElement(SheetErrorContent, {
        data: data.banner
    });
};
StatsSheetFailureContent.displayName = "StatsSheetFailureContent";
StatsSheetFailureContent.fragment = fragment38;
// src/components/stats/get-stats-query.ts
var getStatsQuery = gql44(_templateObject57(), StatsSheetContent.fragment, StatsSheetFailureContent.fragment);
// src/hooks/use-open-stats-sheet.ts
function useImperativeQuery(query) {
    var refetch = useQuery(query, {
        skip: true
    }).refetch;
    var fetchQuery = useCallback15(function(param) {
        var variables = param.variables;
        return refetch(variables);
    }, [
        refetch
    ]);
    return [
        fetchQuery
    ];
}
function useOpenStatsSheet() {
    var context = useBexApi4().context;
    var _useStripeContext = useStripeContext(), clientContext = _useStripeContext.clientContext, propertyContext = _useStripeContext.propertyContext, setActiveMenu = _useStripeContext.setActiveMenu, setActiveSheet = _useStripeContext.setActiveSheet, setStatsSheetContent = _useStripeContext.setStatsSheetContent;
    var trackEvent = useAnalytics().trackEvent;
    var _useImperativeQuery = _sliced_to_array(useImperativeQuery(getStatsQuery), 1), getStats = _useImperativeQuery[0];
    var openStatsSheet = useCallback15(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(action) {
            var _action_analytics, variables, response, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setStatsSheetContent === null || setStatsSheetContent === void 0 ? void 0 : setStatsSheetContent({
                            type: 2 /* LOADING */ 
                        });
                        setActiveMenu === null || setActiveMenu === void 0 ? void 0 : setActiveMenu("NONE" /* NONE */ );
                        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("STATS" /* STATS */ );
                        action === null || action === void 0 ? void 0 : (_action_analytics = action.analytics) === null || _action_analytics === void 0 ? void 0 : _action_analytics.forEach(trackEvent);
                        variables = {
                            context: context,
                            clientContext: clientContext,
                            request: {
                                propertyContext: propertyContext
                            }
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getStats({
                                variables: variables
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        setStatsSheetContent === null || setStatsSheetContent === void 0 ? void 0 : setStatsSheetContent({
                            type: 3 /* DATA */ ,
                            data: response.data.affiliatesStats
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (action === null || action === void 0 ? void 0 : action.unexpectedErrorMessage) {
                            setStatsSheetContent === null || setStatsSheetContent === void 0 ? void 0 : setStatsSheetContent({
                                type: 3 /* DATA */ ,
                                data: action.unexpectedErrorMessage
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(action) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setStatsSheetContent,
        setActiveMenu,
        setActiveSheet,
        getStats,
        trackEvent,
        context,
        clientContext,
        propertyContext
    ]);
    return {
        openStatsSheet: openStatsSheet
    };
}
// src/hooks/use-track-carousel-event.ts
import { useCallback as useCallback16 } from "react";
var useTrackCarouselEvent = function() {
    var trackEvent = useAnalytics().trackEvent;
    var trackCarouselEvent = useCallback16(function(currentIndex, previousIndex, nextButtonEvents, previousButtonEvents) {
        if (currentIndex > previousIndex) {
            nextButtonEvents === null || nextButtonEvents === void 0 ? void 0 : nextButtonEvents.forEach(trackEvent);
        } else if (currentIndex < previousIndex) {
            previousButtonEvents === null || previousButtonEvents === void 0 ? void 0 : previousButtonEvents.forEach(trackEvent);
        }
    }, [
        trackEvent
    ]);
    return {
        trackCarouselEvent: trackCarouselEvent
    };
};
// src/hooks/use-form-validation.ts
import { useMemo as useMemo16 } from "react";
function useFormValidation(validations) {
    var requiredValidation = useMemo16(function() {
        return (validations || []).find(function(validation) {
            return validation.__typename === "EGDSRequiredInputValidation";
        });
    }, [
        validations
    ]);
    var regexValidation = useMemo16(function() {
        return (validations || []).find(function(validation) {
            return validation.__typename === "EGDSRegexInputValidation";
        });
    }, [
        validations
    ]);
    var required = requiredValidation === null || requiredValidation === void 0 ? void 0 : requiredValidation.errorMessage;
    var pattern = regexValidation ? {
        value: new RegExp(regexValidation.pattern),
        message: regexValidation.errorMessage
    } : void 0;
    return {
        required: required,
        pattern: pattern
    };
}
// src/hooks/use-elements-map.ts
import { useMemo as useMemo17 } from "react";
function useElementsMap(elementsMap) {
    return useMemo17(function() {
        return elementsMap.reduce(function(acc, param) {
            var key = param.key, value = param.value;
            if (key) {
                acc[key] = value;
            }
            return acc;
        }, {});
    }, [
        elementsMap
    ]);
}
// src/components/stripe/affiliates-logo.tsx
var fragment39 = gql45(_templateObject58(), AffiliatesOutwardLinkAction.fragment, AffiliatesEGDSMark.fragment);
var AffiliatesLogo = function(param) {
    var data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = useCallback17(function() {
        var analyticsEvents = data.action.analytics;
        analyticsEvents.forEach(trackEvent);
    }, [
        trackEvent,
        data
    ]);
    return /* @__PURE__ */ React40.createElement(EGDSLink2, {
        theme: "inverse"
    }, /* @__PURE__ */ React40.createElement("a", {
        href: data.action.url,
        target: "_blank",
        rel: "noopener",
        onClick: handleClick
    }, /* @__PURE__ */ React40.createElement(AffiliatesEGDSMark, {
        data: _object_spread_props(_object_spread({}, data.mark), {
            size: "LARGE"
        })
    })));
};
AffiliatesLogo.displayName = "AffiliatesLogo";
AffiliatesLogo.fragment = fragment39;
// src/components/stripe/affiliates-partner-details.tsx
import React42, { useCallback as useCallback19 } from "react";
import { gql as gql47 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex18, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSMenuList } from "@egds/react-core/menu";
import { EGDSSpacing as EGDSSpacing20, EGDSSpacingHr as EGDSSpacingHr5 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText16 } from "@egds/react-core/text";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/stripe/affiliates-close-toolbar-dialog.tsx
import React41, { useCallback as useCallback18, useEffect as useEffect7, useMemo as useMemo18, useRef as useRef2, useState as useState17 } from "react";
import { gql as gql46, useMutation as useMutation4 } from "@apollo/client";
import { EGDSPrimaryButton as EGDSPrimaryButton2, EGDSTertiaryButton as EGDSTertiaryButton3 } from "@egds/react-core/button";
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSLoader as EGDSLoader5 } from "@egds/react-core/loader";
import { EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading15 } from "@egds/react-core/text";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { useDialog } from "@shared-ui/dialog-context";
var fragment40 = gql46(_templateObject59(), AffiliatesSpannableText.fragment, AffiliatesButton.fragment, AffiliatesEGDSBanner.fragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesCloseToolbarDialog = function(param) {
    var data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var triggerRef = useRef2(null);
    var _useDialog = _sliced_to_array(useDialog("affiliates-close-toolbar-dialog" /* CLOSE_TOOLBAR */ ), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var _useMutation4 = _sliced_to_array(useMutation4(closeToolbarMutation), 2), closeToolbar = _useMutation4[0], loading = _useMutation4[1].loading;
    var context = useBexApi5().context;
    var _useStripeContext = useStripeContext(), clientContext = _useStripeContext.clientContext, setIsToolbarClosed = _useStripeContext.setIsToolbarClosed;
    var _useState17 = _sliced_to_array(useState17(null), 2), failureResponse = _useState17[0], setFailureResponse = _useState17[1];
    var closeToolbarAction = data.closeToolbarButton.action;
    var cancelAction = data.cancelButton.action;
    var showProgress = useMemo18(function() {
        return data.closeToolbarButton.showActionProgress === true && loading;
    }, [
        data.closeToolbarButton.showActionProgress,
        loading
    ]);
    var handleCloseToolbar = useCallback18(/*#__PURE__*/ _async_to_generator(function() {
        var _response_data, response, closeAffiliateToolbar, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setFailureResponse(null);
                    if (closeToolbarAction.__typename === "AffiliatesCloseToolbarAction") {
                        closeToolbarAction.analytics.forEach(trackEvent);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        closeToolbar({
                            variables: {
                                context: context,
                                clientContext: clientContext
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    closeAffiliateToolbar = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.closeAffiliateToolbar;
                    if ((closeAffiliateToolbar === null || closeAffiliateToolbar === void 0 ? void 0 : closeAffiliateToolbar.__typename) === "AffiliatesCloseToolbarSuccessResponse") {
                        setIsToolbarClosed === null || setIsToolbarClosed === void 0 ? void 0 : setIsToolbarClosed(true);
                        dialogActions.closeDialog();
                    } else if ((closeAffiliateToolbar === null || closeAffiliateToolbar === void 0 ? void 0 : closeAffiliateToolbar.__typename) === "AffiliatesCloseToolbarFailureResponse") {
                        setFailureResponse(closeAffiliateToolbar.banner);
                    }
                    closeAffiliateToolbar === null || closeAffiliateToolbar === void 0 ? void 0 : closeAffiliateToolbar.impressionAnalytics.forEach(trackEvent);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    if (closeToolbarAction.__typename === "AffiliatesCloseToolbarAction") {
                        setFailureResponse(closeToolbarAction.unexpectedErrorMessage);
                    }
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        trackEvent,
        closeToolbarAction,
        dialogActions,
        closeToolbar,
        context,
        clientContext,
        setIsToolbarClosed
    ]);
    var handleCancel = useCallback18(function() {
        if (cancelAction.__typename === "AffiliatesCancelAction") {
            cancelAction.analytics.forEach(trackEvent);
        }
        dialogActions.closeDialog();
    }, [
        trackEvent,
        cancelAction,
        dialogActions
    ]);
    useEffect7(function() {
        if (!isDialogOpen) {
            setFailureResponse(null);
        }
    }, [
        isDialogOpen
    ]);
    return /* @__PURE__ */ React41.createElement(EGDSSheetTransition3, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React41.createElement(DialogComponent, null, /* @__PURE__ */ React41.createElement(EGDSDialog, {
        returnFocusOnClose: true,
        dialogShow: isDialogOpen,
        triggerRef: triggerRef
    }, /* @__PURE__ */ React41.createElement(EGDSDialogContent, {
        key: "affiliates-close-toolbar-dialog.content"
    }, /* @__PURE__ */ React41.createElement(EGDSHeading15, {
        tag: "h2",
        size: 5,
        key: "affiliates-close-toolbar-dialog.content.heading"
    }, data.title), data.content.map(function(paragraph, paragraphIndex) {
        return /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
            margin: {
                blockstart: "three"
            },
            key: "Affiliates-Close-Toolbar-Dialog-Content-".concat(paragraphIndex)
        }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(AffiliatesSpannableText, {
            data: paragraph
        })));
    }), failureResponse && /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(AffiliatesEGDSBanner, {
        data: failureResponse
    }))), /* @__PURE__ */ React41.createElement(EGDSDialogFooter, {
        key: "EGDSDialogFooter",
        stacked: true
    }, /* @__PURE__ */ React41.createElement(EGDSPrimaryButton2, {
        disabled: showProgress,
        onClick: handleCloseToolbar
    }, showProgress ? /* @__PURE__ */ React41.createElement(EGDSSpacing19, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSLoader5, {
        isSmall: true,
        isDarkBackground: true
    }))) : data.closeToolbarButton.button.primary), /* @__PURE__ */ React41.createElement(EGDSTertiaryButton3, {
        onClick: handleCancel
    }, data.cancelButton.button.primary))))));
};
AffiliatesCloseToolbarDialog.displayName = "AffiliatesCloseToolbarDialog";
AffiliatesCloseToolbarDialog.fragment = fragment40;
// src/components/stripe/affiliates-partner-details.tsx
var fragment41 = gql47(_templateObject60(), AffiliatesStandardLink.fragment, AffiliatesOutwardLinkAction.fragment, AffiliatesButton.fragment, AffiliatesCloseToolbarDialog.fragment, AffiliatesAnalytics.interactionFragment);
var AffiliatesPartnerDetails = function(param) {
    var data = param.data;
    var _data_linkHistory, _data_account, _data_help, _data_openCloseToolbarDialogButton, _data_linkHistory1, _data_account1, _data_help1;
    var trackEvent = useAnalytics().trackEvent;
    var _useDialog2 = _sliced_to_array(useDialog2("affiliates-close-toolbar-dialog" /* CLOSE_TOOLBAR */ ), 2), dialogActions = _useDialog2[1];
    var setActiveMenu = useStripeContext().setActiveMenu;
    var linkHistoryAction = data === null || data === void 0 ? void 0 : (_data_linkHistory = data.linkHistory) === null || _data_linkHistory === void 0 ? void 0 : _data_linkHistory.action;
    var accountAction = data === null || data === void 0 ? void 0 : (_data_account = data.account) === null || _data_account === void 0 ? void 0 : _data_account.action;
    var helpAction = data === null || data === void 0 ? void 0 : (_data_help = data.help) === null || _data_help === void 0 ? void 0 : _data_help.action;
    var openCloseToolbarDialogAction = data === null || data === void 0 ? void 0 : (_data_openCloseToolbarDialogButton = data.openCloseToolbarDialogButton) === null || _data_openCloseToolbarDialogButton === void 0 ? void 0 : _data_openCloseToolbarDialogButton.action;
    var openCloseToolbarButton = data === null || data === void 0 ? void 0 : data.openCloseToolbarDialogButton;
    var handleExternalLinkClick = useCallback19(function(action) {
        action.analytics.forEach(trackEvent);
        setActiveMenu === null || setActiveMenu === void 0 ? void 0 : setActiveMenu("NONE" /* NONE */ );
    }, [
        trackEvent,
        setActiveMenu
    ]);
    var handleOpenCloseToolbarDialog = useCallback19(function() {
        if (openCloseToolbarDialogAction.__typename === "AffiliatesOpenCloseToolbarDialogAction") {
            openCloseToolbarDialogAction.analytics.forEach(trackEvent);
        }
        dialogActions.openDialog();
        setActiveMenu === null || setActiveMenu === void 0 ? void 0 : setActiveMenu("NONE" /* NONE */ );
    }, [
        trackEvent,
        setActiveMenu,
        openCloseToolbarDialogAction,
        dialogActions
    ]);
    return /* @__PURE__ */ React42.createElement(EGDSLayoutFlex18, {
        direction: "column"
    }, /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React42.createElement(EGDSSpacing20, {
        margin: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSText16, {
        size: 400,
        weight: "medium",
        theme: "emphasis",
        whiteSpace: "nowrap"
    }, data === null || data === void 0 ? void 0 : data.name), /* @__PURE__ */ React42.createElement(EGDSText16, {
        size: 200,
        weight: "regular",
        theme: "standard",
        whiteSpace: "nowrap",
        overflow: "truncate"
    }, /* @__PURE__ */ React42.createElement("span", {
        title: data === null || data === void 0 ? void 0 : data.email
    }, data === null || data === void 0 ? void 0 : data.email))))), /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSSpacingHr5, {
        blockMargin: "three"
    }))), /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React42.createElement(EGDSMenuList, {
        items: [
            {
                attributes: {
                    role: "menuitem"
                },
                className: "uitk-list-item",
                label: data === null || data === void 0 ? void 0 : (_data_linkHistory1 = data.linkHistory) === null || _data_linkHistory1 === void 0 ? void 0 : _data_linkHistory1.text,
                typeAnchor: true,
                href: linkHistoryAction === null || linkHistoryAction === void 0 ? void 0 : linkHistoryAction.url,
                target: "_blank",
                rel: "noopener",
                onClick: function() {
                    return handleExternalLinkClick(linkHistoryAction);
                }
            },
            {
                attributes: {
                    role: "menuitem"
                },
                className: "uitk-list-item",
                label: data === null || data === void 0 ? void 0 : (_data_account1 = data.account) === null || _data_account1 === void 0 ? void 0 : _data_account1.text,
                typeAnchor: true,
                href: accountAction === null || accountAction === void 0 ? void 0 : accountAction.url,
                target: "_blank",
                rel: "noopener",
                onClick: function() {
                    return handleExternalLinkClick(accountAction);
                }
            },
            {
                attributes: {
                    role: "menuitem"
                },
                className: "uitk-list-item",
                label: data === null || data === void 0 ? void 0 : (_data_help1 = data.help) === null || _data_help1 === void 0 ? void 0 : _data_help1.text,
                typeAnchor: true,
                href: helpAction === null || helpAction === void 0 ? void 0 : helpAction.url,
                target: "_blank",
                rel: "noopener",
                onClick: function() {
                    return handleExternalLinkClick(helpAction);
                }
            }
        ]
    })), /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSSpacingHr5, {
        blockMargin: "three"
    }))), /* @__PURE__ */ React42.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */ React42.createElement(EGDSMenuList, {
        items: [
            {
                attributes: {
                    role: "menuitem"
                },
                className: "uitk-list-item",
                label: data.openCloseToolbarDialogButton.button.primary || "",
                icon: openCloseToolbarButton.button.icon ? {
                    component: /* @__PURE__ */ React42.createElement(AffiliatesEGDSIcon, {
                        data: openCloseToolbarButton.button.icon
                    })
                } : {},
                typeAnchor: false,
                onClick: handleOpenCloseToolbarDialog
            }
        ]
    })));
};
AffiliatesPartnerDetails.displayName = "AffiliatesPartnerDetails";
AffiliatesPartnerDetails.fragment = fragment41;
// src/components/stripe/stripe-page-link-button.tsx
import React43, { useCallback as useCallback20 } from "react";
import { gql as gql48 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment42 = gql48(_templateObject61(), AffiliatesButton.fragment, AffiliatesCreateLinkAction.fragment);
var StripePageLinkButton = function(param) {
    var _param_data = param.data, button = _param_data.button, action = _param_data.action;
    var linkSheetTriggerRef = useStripeContext().linkSheetTriggerRef;
    var openLinkSheet = useOpenLinkSheet().openLinkSheet;
    var handleClick = useCallback20(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(action.__typename === "AffiliatesCreateLinkAction")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        openLinkSheet(action)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        openLinkSheet,
        action
    ]);
    return /* @__PURE__ */ React43.createElement(Viewport, null, /* @__PURE__ */ React43.createElement(ViewSmall, null, /* @__PURE__ */ React43.createElement(EGDSPrimaryButton3, {
        domRef: linkSheetTriggerRef,
        size: EGDSButtonSize2.MEDIUM,
        isFullWidth: true,
        disabled: false,
        onClick: handleClick
    }, button.icon && /* @__PURE__ */ React43.createElement(EGDSIcon4, {
        name: button.icon.token,
        size: EGDSIconSize2.MEDIUM
    }), /* @__PURE__ */ React43.createElement("span", {
        className: "uitk-text-white-space-nowrap"
    }, button.primary))), /* @__PURE__ */ React43.createElement(ViewMedium, null, /* @__PURE__ */ React43.createElement(EGDSPrimaryButton3, {
        domRef: linkSheetTriggerRef,
        size: EGDSButtonSize2.MEDIUM,
        inverse: true,
        disabled: false,
        onClick: handleClick
    }, button.icon && /* @__PURE__ */ React43.createElement(EGDSIcon4, {
        name: button.icon.token,
        size: EGDSIconSize2.MEDIUM
    }), /* @__PURE__ */ React43.createElement("span", {
        className: "uitk-text-white-space-nowrap"
    }, button.primary))));
};
StripePageLinkButton.displayName = "StripePageLinkButton";
StripePageLinkButton.fragment = fragment42;
// src/components/stripe/stripe-page-stats-button.tsx
import React44, { useCallback as useCallback21 } from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize3, EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var fragment43 = gql49(_templateObject62(), AffiliatesButton.fragment, AffiliatesViewStatsAction.fragment);
var StripePageStatsButton = function(param) {
    var _param_data = param.data, button = _param_data.button, action = _param_data.action;
    var statsSheetTriggerRef = useStripeContext().statsSheetTriggerRef;
    var openStatsSheet = useOpenStatsSheet().openStatsSheet;
    var handleButtonClick = useCallback21(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(action.__typename === "AffiliatesViewStatsAction")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        openStatsSheet(action)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        action,
        openStatsSheet
    ]);
    return /* @__PURE__ */ React44.createElement(Viewport2, null, /* @__PURE__ */ React44.createElement(ViewSmall2, null, /* @__PURE__ */ React44.createElement(EGDSSecondaryButton2, {
        domRef: statsSheetTriggerRef,
        size: EGDSButtonSize3.MEDIUM,
        isFullWidth: true,
        disabled: button.disabled,
        onClick: handleButtonClick
    }, button.icon && /* @__PURE__ */ React44.createElement(EGDSIcon5, {
        name: button.icon.token,
        size: EGDSIconSize3.MEDIUM
    }), /* @__PURE__ */ React44.createElement("span", {
        className: "uitk-text-white-space-nowrap"
    }, button.primary))), /* @__PURE__ */ React44.createElement(ViewMedium2, null, /* @__PURE__ */ React44.createElement(EGDSSecondaryButton2, {
        domRef: statsSheetTriggerRef,
        size: EGDSButtonSize3.MEDIUM,
        inverse: true,
        disabled: button.disabled,
        onClick: handleButtonClick
    }, button.icon && /* @__PURE__ */ React44.createElement(EGDSIcon5, {
        name: button.icon.token,
        size: EGDSIconSize3.MEDIUM
    }), /* @__PURE__ */ React44.createElement("span", {
        className: "uitk-text-white-space-nowrap"
    }, button.primary))));
};
StripePageStatsButton.displayName = "StripePageStatsButton";
StripePageStatsButton.fragment = fragment43;
// src/components/stripe/stripe-sheets.tsx
import React46, { useCallback as useCallback23 } from "react";
// src/components/stats/stats-sheet.tsx
import React45, { useCallback as useCallback22, useEffect as useEffect8 } from "react";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent3, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar2, EGDSToolbarButton as EGDSToolbarButton2 } from "@egds/react-core/toolbar";
function SheetContent(param) {
    var data = param.data;
    switch(data.__typename){
        case "AffiliatesLodgingStatsSuccessResponse":
            return /* @__PURE__ */ React45.createElement(StatsSheetContent, {
                data: data
            });
        case "AffiliatesStatsFailureResponse":
            return /* @__PURE__ */ React45.createElement(StatsSheetFailureContent, {
                data: data
            });
        case "UIBanner":
        default:
            return /* @__PURE__ */ React45.createElement(SheetErrorContent, {
                data: data
            });
    }
}
function GetLinkAction(param) {
    var data = param.data, onClick = param.onClick;
    switch(data === null || data === void 0 ? void 0 : data.__typename){
        case "AffiliatesLodgingStatsSuccessResponse":
            return (data === null || data === void 0 ? void 0 : data.getLink) ? /* @__PURE__ */ React45.createElement(EGDSToolbarButton2, {
                onClick: onClick
            }, data === null || data === void 0 ? void 0 : data.getLink.text) : null;
        case "AffiliatesStatsFailureResponse":
            return (data === null || data === void 0 ? void 0 : data.getLink) ? /* @__PURE__ */ React45.createElement(EGDSToolbarButton2, {
                onClick: onClick
            }, data === null || data === void 0 ? void 0 : data.getLink.text) : null;
        case "UIBanner":
        default:
            return null;
    }
}
var StatsSheet = function(param) {
    var onSheetToolbarClick = param.onSheetToolbarClick, loading = param.loading, data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var _useStripeContext = useStripeContext(), statsSheetTriggerRef = _useStripeContext.statsSheetTriggerRef, activeSheet = _useStripeContext.activeSheet, setActiveSheet = _useStripeContext.setActiveSheet;
    var handleCloseButtonClick = useCallback22(function() {
        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("NONE" /* NONE */ );
        if ((data === null || data === void 0 ? void 0 : data.__typename) !== "UIBanner") {
            var _data_closeAction_analytics;
            data === null || data === void 0 ? void 0 : (_data_closeAction_analytics = data.closeAction.analytics) === null || _data_closeAction_analytics === void 0 ? void 0 : _data_closeAction_analytics.forEach(trackEvent);
        }
    }, [
        setActiveSheet,
        trackEvent,
        data
    ]);
    useEffect8(function() {
        if ((data === null || data === void 0 ? void 0 : data.__typename) !== "UIBanner") {
            var _data_impressionAnalytics;
            data === null || data === void 0 ? void 0 : (_data_impressionAnalytics = data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics.forEach(trackEvent);
        }
    }, [
        trackEvent,
        data
    ]);
    return /* @__PURE__ */ React45.createElement(EGDSSheetTransition4, {
        isVisible: activeSheet === "STATS" /* STATS */ 
    }, /* @__PURE__ */ React45.createElement(EGDSSheet3, {
        type: "side",
        triggerRef: statsSheetTriggerRef,
        isVisible: activeSheet === "STATS" /* STATS */ 
    }, /* @__PURE__ */ React45.createElement(EGDSToolbar2, {
        navigationContent: {
            navIconLabel: "Close",
            onClick: handleCloseButtonClick
        },
        toolbarActionContent: /* @__PURE__ */ React45.createElement(GetLinkAction, {
            data: data,
            onClick: onSheetToolbarClick
        })
    }), /* @__PURE__ */ React45.createElement(EGDSSheetContent3, {
        padded: false
    }, loading && /* @__PURE__ */ React45.createElement(SheetLoader, null), !loading && data && /* @__PURE__ */ React45.createElement(SheetContent, {
        data: data
    }))));
};
// src/components/stripe/stripe-sheets.tsx
var StripeSheets = function() {
    var _useStripeContext = useStripeContext(), linkSheetContent = _useStripeContext.linkSheetContent, statsSheetContent = _useStripeContext.statsSheetContent;
    var openLinkSheet = useOpenLinkSheet().openLinkSheet;
    var openStatsSheet = useOpenStatsSheet().openStatsSheet;
    var isLinkSheetLoading = linkSheetContent.type === 2 /* LOADING */ ;
    var isStatsSheetLoading = statsSheetContent.type === 2 /* LOADING */ ;
    var handleLinkSheetToolbarClick = useCallback23(function() {
        var _linkSheetContent_data;
        switch((_linkSheetContent_data = linkSheetContent.data) === null || _linkSheetContent_data === void 0 ? void 0 : _linkSheetContent_data.__typename){
            case "AffiliatesCreateLinkLodgingSuccessResponse":
            case "AffiliatesCreateLinkDefaultSuccessResponse":
            case "AffiliatesCreateLinkFailureResponse":
                {
                    var _linkSheetContent_data_statsLink;
                    var viewStatsAction = ((_linkSheetContent_data_statsLink = linkSheetContent.data.statsLink) === null || _linkSheetContent_data_statsLink === void 0 ? void 0 : _linkSheetContent_data_statsLink.action.__typename) === "AffiliatesViewStatsAction" ? linkSheetContent.data.statsLink.action : void 0;
                    return openStatsSheet(viewStatsAction);
                }
            default:
        }
    }, [
        linkSheetContent.data,
        openStatsSheet
    ]);
    var handleStatsSheetToolbarClick = useCallback23(function() {
        var _statsSheetContent_data;
        switch((_statsSheetContent_data = statsSheetContent.data) === null || _statsSheetContent_data === void 0 ? void 0 : _statsSheetContent_data.__typename){
            case "AffiliatesLodgingStatsSuccessResponse":
            case "AffiliatesStatsFailureResponse":
                {
                    var _statsSheetContent_data_getLink;
                    var createLinkAction = ((_statsSheetContent_data_getLink = statsSheetContent.data.getLink) === null || _statsSheetContent_data_getLink === void 0 ? void 0 : _statsSheetContent_data_getLink.action.__typename) === "AffiliatesCreateLinkAction" ? statsSheetContent.data.getLink.action : void 0;
                    return openLinkSheet(createLinkAction);
                }
            default:
        }
    }, [
        openLinkSheet,
        statsSheetContent.data
    ]);
    return /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(LinkSheet, {
        onSheetToolbarClick: handleLinkSheetToolbarClick,
        loading: isLinkSheetLoading,
        data: linkSheetContent.data
    }), /* @__PURE__ */ React46.createElement(StatsSheet, {
        onSheetToolbarClick: handleStatsSheetToolbarClick,
        loading: isStatsSheetLoading,
        data: statsSheetContent.data
    }));
};
// src/components/stripe/stripe-toolbar.tsx
import React52, { useEffect as useEffect9 } from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex21, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/components/stripe/stripe-page-nav.tsx
import React49 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/stripe/stripe-page-menu.tsx
import React48, { useCallback as useCallback24 } from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex19, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
// src/components/stripe/stripe-page-menu-button.tsx
import React47 from "react";
import { EGDSButtonSize as EGDSButtonSize4, EGDSSecondaryButton as EGDSSecondaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon6, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
var StripePageMenuButton = function(props) {
    return /* @__PURE__ */ React47.createElement(EGDSSecondaryButton3, _object_spread_props(_object_spread({}, props), {
        size: EGDSButtonSize4.MEDIUM,
        inverse: true
    }), /* @__PURE__ */ React47.createElement(EGDSIcon6, {
        id: "eg-stripe-page-menu-icon",
        name: "menu",
        title: "Page",
        size: EGDSIconSize4.MEDIUM
    }));
};
// src/components/stripe/stripe-page-menu.tsx
var StripePageMenu = function(param) {
    var data = param.data;
    var _useStripeContext = useStripeContext(), activeMenu = _useStripeContext.activeMenu, setActiveSheet = _useStripeContext.setActiveSheet, toggleActiveMenu = _useStripeContext.toggleActiveMenu;
    var handleMenuTriggerClick = useCallback24(function() {
        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("NONE" /* NONE */ );
        toggleActiveMenu === null || toggleActiveMenu === void 0 ? void 0 : toggleActiveMenu("PAGE" /* PAGE */ );
    }, [
        setActiveSheet,
        toggleActiveMenu
    ]);
    return /* @__PURE__ */ React48.createElement(EGDSMenu, {
        isOpen: activeMenu === "PAGE" /* PAGE */ ,
        onTriggerClick: handleMenuTriggerClick
    }, /* @__PURE__ */ React48.createElement(EGDSMenuTrigger, null, /* @__PURE__ */ React48.createElement(StripePageMenuButton, null)), /* @__PURE__ */ React48.createElement(EGDSMenuContainer, {
        width: 260,
        position: PositionType.RIGHT,
        autoPosition: false
    }, /* @__PURE__ */ React48.createElement(EGDSSpacing21, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React48.createElement(EGDSLayoutFlex19, {
        direction: "column",
        space: "six"
    }, data.statsButton && /* @__PURE__ */ React48.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(StripePageStatsButton, {
        data: data.statsButton
    }))), data.getLinkButton && /* @__PURE__ */ React48.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(StripePageLinkButton, {
        data: data.getLinkButton
    })))))));
};
// src/components/stripe/stripe-page-nav.tsx
var StripePageNav = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React49.createElement(Viewport3, null, /* @__PURE__ */ React49.createElement(ViewSmall3, null, /* @__PURE__ */ React49.createElement(StripePageMenu, {
        data: data
    })), /* @__PURE__ */ React49.createElement(ViewMedium3, null, /* @__PURE__ */ React49.createElement(EGDSLayoutFlex20, {
        direction: "row",
        space: "four"
    }, data.statsButton && /* @__PURE__ */ React49.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(StripePageStatsButton, {
        data: data.statsButton
    }))), data.getLinkButton && /* @__PURE__ */ React49.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(StripePageLinkButton, {
        data: data.getLinkButton
    }))))));
};
// src/components/stripe/stripe-partner-menu.tsx
import React51, { useCallback as useCallback25 } from "react";
import { EGDSMenu as EGDSMenu2, EGDSMenuContainer as EGDSMenuContainer2, EGDSMenuTrigger as EGDSMenuTrigger2, PositionType as PositionType2 } from "@egds/react-core/menu";
// src/components/stripe/stripe-partner-menu-button.tsx
import React50 from "react";
import { EGDSButtonSize as EGDSButtonSize5, EGDSTertiaryButton as EGDSTertiaryButton4 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon7, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var StripePartnerMenuButton = function(_param) {
    var button = _param.data.button, otherProps = _object_without_properties(_param, [
        "data"
    ]);
    var _button_primary;
    return /* @__PURE__ */ React50.createElement(Viewport4, null, /* @__PURE__ */ React50.createElement(ViewSmall4, null, /* @__PURE__ */ React50.createElement(EGDSTertiaryButton4, _object_spread_props(_object_spread({}, otherProps), {
        size: EGDSButtonSize5.MEDIUM,
        inverse: true
    }), button.icon && /* @__PURE__ */ React50.createElement(EGDSIcon7, {
        id: "eg-stripe-partner-menu-icon",
        name: button.icon.token,
        title: (_button_primary = button.primary) !== null && _button_primary !== void 0 ? _button_primary : "",
        size: EGDSIconSize5.MEDIUM
    }))), /* @__PURE__ */ React50.createElement(ViewMedium4, null, /* @__PURE__ */ React50.createElement(EGDSTertiaryButton4, _object_spread_props(_object_spread({}, otherProps), {
        size: EGDSButtonSize5.MEDIUM,
        inverse: true
    }), button.icon && /* @__PURE__ */ React50.createElement(EGDSIcon7, {
        id: "eg-stripe-partner-menu-icon",
        name: button.icon.token,
        size: EGDSIconSize5.MEDIUM
    }), /* @__PURE__ */ React50.createElement("span", {
        className: "uitk-text-white-space-nowrap"
    }, button.primary), /* @__PURE__ */ React50.createElement(EGDSIcon7, {
        name: "expand_more"
    }))));
};
// src/components/stripe/stripe-partner-menu.tsx
var StripePartnerMenu = function(param) {
    var data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var _useStripeContext = useStripeContext(), activeMenu = _useStripeContext.activeMenu, setActiveSheet = _useStripeContext.setActiveSheet, toggleActiveMenu = _useStripeContext.toggleActiveMenu;
    var handleMenuTriggerClick = useCallback25(function() {
        setActiveSheet === null || setActiveSheet === void 0 ? void 0 : setActiveSheet("NONE" /* NONE */ );
        toggleActiveMenu === null || toggleActiveMenu === void 0 ? void 0 : toggleActiveMenu("PARTNER" /* PARTNER */ );
        if (data.openPartnerDetailsButton.action.__typename === "AffiliatesOpenPartnerDetailsAction") {
            data.openPartnerDetailsButton.action.analytics.forEach(trackEvent);
        }
    }, [
        toggleActiveMenu,
        setActiveSheet,
        trackEvent,
        data
    ]);
    return /* @__PURE__ */ React51.createElement(React51.Fragment, null, /* @__PURE__ */ React51.createElement(EGDSMenu2, {
        isOpen: activeMenu === "PARTNER" /* PARTNER */ ,
        onTriggerClick: handleMenuTriggerClick
    }, /* @__PURE__ */ React51.createElement(EGDSMenuTrigger2, null, /* @__PURE__ */ React51.createElement(StripePartnerMenuButton, {
        data: data.openPartnerDetailsButton
    })), /* @__PURE__ */ React51.createElement(EGDSMenuContainer2, {
        width: 260,
        position: PositionType2.LEFT,
        autoPosition: false
    }, /* @__PURE__ */ React51.createElement(AffiliatesPartnerDetails, {
        data: data.partnerDetails
    }))), /* @__PURE__ */ React51.createElement(AffiliatesCloseToolbarDialog, {
        data: data.partnerDetails.closeToolbarDialog
    }));
};
// src/components/stripe/stripe-toolbar.tsx
var StripeToolbar = function(param) {
    var data = param.data;
    var trackEvent = useAnalytics().trackEvent;
    var isToolbarClosed = useStripeContext().isToolbarClosed;
    useEffect9(function() {
        var _data_impressionAnalytics;
        (_data_impressionAnalytics = data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics.forEach(trackEvent);
    }, [
        trackEvent,
        data.impressionAnalytics
    ]);
    if (isToolbarClosed) {
        return null;
    }
    return /* @__PURE__ */ React52.createElement(Viewport5, null, /* @__PURE__ */ React52.createElement(ViewSmall5, null, /* @__PURE__ */ React52.createElement(EGDSSpacing22, {
        padding: {
            block: "three",
            inlinestart: "four",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlex21, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(StripePartnerMenu, {
        data: data
    }))), data.logo && /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(AffiliatesLogo, {
        data: data.logo
    }))), /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(StripePageNav, {
        data: data
    })))))), /* @__PURE__ */ React52.createElement(ViewMedium5, null, /* @__PURE__ */ React52.createElement(EGDSSpacing22, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlex21, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(EGDSLayoutFlex21, {
        direction: "row",
        space: "six",
        alignItems: "center"
    }, data.logo && /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(AffiliatesLogo, {
        data: data.logo
    }))), /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(StripePartnerMenu, {
        data: data
    })))))), /* @__PURE__ */ React52.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */ React52.createElement("div", null, /* @__PURE__ */ React52.createElement(StripePageNav, {
        data: data
    })))))));
};
// src/components/stripe/stripe.tsx
var successResponseFragment = gql50(_templateObject63(), AffiliatesAnalytics.impressionFragment, AffiliatesButton.fragment, AffiliatesLogo.fragment, AffiliatesPartnerDetails.fragment, AffiliatesEGDSBanner.fragment, StripePageLinkButton.fragment, StripePageStatsButton.fragment);
var __Query = gql50(_templateObject64(), successResponseFragment);
var Stripe = function(param) {
    var skipSsr = param.skipSsr, inputs = param.inputs;
    var context = useBexApi6().context;
    var clientContext = useMemo19(function() {
        return getClientContext(inputs.pageId);
    }, [
        inputs.pageId
    ]);
    var propertyContext = useMemo19(function() {
        return getPropertyContext(inputs.targetUrl, inputs.site, clientContext);
    }, [
        inputs.targetUrl,
        inputs.site,
        clientContext
    ]);
    var _useQuery2 = useQuery2(__Query, {
        variables: {
            context: context,
            clientContext: clientContext
        },
        ssr: !skipSsr
    }), loading = _useQuery2.loading, data = _useQuery2.data, error = _useQuery2.error;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.affiliatesStripe) || data.affiliatesStripe.__typename !== "AffiliatesStripeSuccessResponse") {
        return null;
    }
    return /* @__PURE__ */ React53.createElement(StripeContextProvider, {
        clientContext: clientContext,
        propertyContext: propertyContext,
        targetUrl: inputs.targetUrl
    }, /* @__PURE__ */ React53.createElement(StripeToolbar, {
        data: data.affiliatesStripe
    }), /* @__PURE__ */ React53.createElement(StripeSheets, null));
};
Stripe.displayName = "sharedui-Stripe";
export { Stripe };
//# sourceMappingURL=index.js.map